import { IWarrantyRepository } from '@/warranty/domain/repositories/warranty.repository';

export const dummySites: IWarrantyRepository.ListSitesOutput = {
  sites: [
    {
      id: '12345',
      groupFullId: 'Country_Corner',
      fullFrontendId: 'Country_Corner',
    },
    {
      id: '23456',
      groupFullId: 'Sunset_Plaza',
      fullFrontendId: 'Sunset_Plaza',
    },
    { id: '34567', groupFullId: 'Smart_Hill', fullFrontendId: 'Smart_Hill' },
  ],
};

export const dummyTops: {
  tops: {
    id: string;
    groupFullId: string;
    topFullId: string;
    fullFrontendId: string;
  }[];
} = {
  tops: [
    {
      id: '9739835394366000',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B01',
      fullFrontendId: 'Country_Corner/B01',
    },
    {
      id: '14115102612756205',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B02',
      fullFrontendId: 'Country_Corner/B02',
    },
    {
      id: '65852267895348562',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B03',
      fullFrontendId: 'Country_Corner/B03',
    },
    {
      id: '32524247218213010',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B04',
      fullFrontendId: 'Country_Corner/B04',
    },
    {
      id: '15142662163423298',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B05',
      fullFrontendId: 'Country_Corner/B05',
    },
    {
      id: '18544298069061869',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B06',
      fullFrontendId: 'Country_Corner/B06',
    },
    {
      id: '66868980844720849',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B07',
      fullFrontendId: 'Country_Corner/B07',
    },
    {
      id: '47756555087370039',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B08',
      fullFrontendId: 'Country_Corner/B08',
    },
    {
      id: '48132666588666541',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B09',
      fullFrontendId: 'Country_Corner/B09',
    },
    {
      id: '17871600849759120',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B10',
      fullFrontendId: 'Country_Corner/B10',
    },
    {
      id: '56724886883381766',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B11',
      fullFrontendId: 'Country_Corner/B11',
    },
    {
      id: '23128282883536391',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B12',
      fullFrontendId: 'Country_Corner/B12',
    },
    {
      id: '69536875005703131',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B13',
      fullFrontendId: 'Country_Corner/B13',
    },
    {
      id: '41441766571723748',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B14',
      fullFrontendId: 'Country_Corner/B14',
    },
    {
      id: '60754690120106369',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B15',
      fullFrontendId: 'Country_Corner/B15',
    },
    {
      id: '9542469758485020',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B16',
      fullFrontendId: 'Country_Corner/B16',
    },
    {
      id: '15656191718307884',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B17',
      fullFrontendId: 'Country_Corner/B17',
    },
    {
      id: '62043061842966335',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B18',
      fullFrontendId: 'Country_Corner/B18',
    },
    {
      id: '1166578162839735',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B19',
      fullFrontendId: 'Country_Corner/B19',
    },
    {
      id: '65952089403350033',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B20',
      fullFrontendId: 'Country_Corner/B20',
    },
    {
      id: '56779848687839874',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B21',
      fullFrontendId: 'Country_Corner/B21',
    },
    {
      id: '6190551887328680',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B22',
      fullFrontendId: 'Country_Corner/B22',
    },
    {
      id: '28227970039726226',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B23',
      fullFrontendId: 'Country_Corner/B23',
    },
    {
      id: '25686743170497907',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B24',
      fullFrontendId: 'Country_Corner/B24',
    },
    {
      id: '57540051426467851',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B25',
      fullFrontendId: 'Country_Corner/B25',
    },
    {
      id: '25335588316095982',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B26',
      fullFrontendId: 'Country_Corner/B26',
    },
    {
      id: '67465371223031458',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B27',
      fullFrontendId: 'Country_Corner/B27',
    },
    {
      id: '57935239604972820',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B28',
      fullFrontendId: 'Country_Corner/B28',
    },
    {
      id: '26038036222907881',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B29',
      fullFrontendId: 'Country_Corner/B29',
    },
    {
      id: '37567530921115554',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B30',
      fullFrontendId: 'Country_Corner/B30',
    },
    {
      id: '29520743539604972',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B31',
      fullFrontendId: 'Country_Corner/B31',
    },
    {
      id: '68810249463363542',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B01',
      fullFrontendId: 'Smart_Hill/B01',
    },
    {
      id: '26688779656110660',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B02',
      fullFrontendId: 'Smart_Hill/B02',
    },
    {
      id: '5208048146371065',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B03',
      fullFrontendId: 'Smart_Hill/B03',
    },
    {
      id: '52095245272996909',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B04',
      fullFrontendId: 'Smart_Hill/B04',
    },
    {
      id: '62951201805066422',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B05',
      fullFrontendId: 'Smart_Hill/B05',
    },
    {
      id: '42935953921198998',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B06',
      fullFrontendId: 'Smart_Hill/B06',
    },
    {
      id: '54380859669690804',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B07',
      fullFrontendId: 'Smart_Hill/B07',
    },
    {
      id: '55999870768132519',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B08',
      fullFrontendId: 'Smart_Hill/B08',
    },
    {
      id: '17590262253897322',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B09',
      fullFrontendId: 'Smart_Hill/B09',
    },
    {
      id: '51937854157168776',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B10',
      fullFrontendId: 'Smart_Hill/B10',
    },
    {
      id: '90998129563161',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B11',
      fullFrontendId: 'Smart_Hill/B11',
    },
    {
      id: '20240335320536014',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B12',
      fullFrontendId: 'Smart_Hill/B12',
    },
    {
      id: '20859898438017379',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B13',
      fullFrontendId: 'Smart_Hill/B13',
    },
    {
      id: '7968654005981071',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B14',
      fullFrontendId: 'Smart_Hill/B14',
    },
    {
      id: '28520624921613308',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B15',
      fullFrontendId: 'Smart_Hill/B15',
    },
    {
      id: '14397688147389146',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B16',
      fullFrontendId: 'Smart_Hill/B16',
    },
    {
      id: '4973799425202413',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B17',
      fullFrontendId: 'Smart_Hill/B17',
    },
    {
      id: '70720494449034970',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B18',
      fullFrontendId: 'Smart_Hill/B18',
    },
    {
      id: '52453168776388276',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B19',
      fullFrontendId: 'Smart_Hill/B19',
    },
    {
      id: '65006415899326271',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B20',
      fullFrontendId: 'Smart_Hill/B20',
    },
    {
      id: '4671598442638018',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B21',
      fullFrontendId: 'Smart_Hill/B21',
    },
    {
      id: '2612182939287076',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B22',
      fullFrontendId: 'Smart_Hill/B22',
    },
    {
      id: '25931767534931922',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B23',
      fullFrontendId: 'Smart_Hill/B23',
    },
    {
      id: '12521425487257130',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B24',
      fullFrontendId: 'Smart_Hill/B24',
    },
    {
      id: '30718404103119905',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B01',
      fullFrontendId: 'Sunset_Plaza/B01',
    },
    {
      id: '20132512127652605',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B02',
      fullFrontendId: 'Sunset_Plaza/B02',
    },
    {
      id: '26375145252243301',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B03',
      fullFrontendId: 'Sunset_Plaza/B03',
    },
    {
      id: '40744635163444372',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B04',
      fullFrontendId: 'Sunset_Plaza/B04',
    },
    {
      id: '47538560548968574',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B05',
      fullFrontendId: 'Sunset_Plaza/B05',
    },
    {
      id: '31073992737191951',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B06',
      fullFrontendId: 'Sunset_Plaza/B06',
    },
    {
      id: '5646263683372337',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B07',
      fullFrontendId: 'Sunset_Plaza/B07',
    },
    {
      id: '25095599520628136',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B08',
      fullFrontendId: 'Sunset_Plaza/B08',
    },
    {
      id: '1869295039075929',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B09',
      fullFrontendId: 'Sunset_Plaza/B09',
    },
    {
      id: '7188901685439760',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B10',
      fullFrontendId: 'Sunset_Plaza/B10',
    },
    {
      id: '37587440701671119',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B11',
      fullFrontendId: 'Sunset_Plaza/B11',
    },
    {
      id: '31646670405234952',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B12',
      fullFrontendId: 'Sunset_Plaza/B12',
    },
    {
      id: '63112088927389728',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B13',
      fullFrontendId: 'Sunset_Plaza/B13',
    },
    {
      id: '71598940471247509',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B14',
      fullFrontendId: 'Sunset_Plaza/B14',
    },
    {
      id: '30419150012822155',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B15',
      fullFrontendId: 'Sunset_Plaza/B15',
    },
    {
      id: '44704272828581916',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B16',
      fullFrontendId: 'Sunset_Plaza/B16',
    },
    {
      id: '58234417308923101',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B17',
      fullFrontendId: 'Sunset_Plaza/B17',
    },
    {
      id: '71738629612187595',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B18',
      fullFrontendId: 'Sunset_Plaza/B18',
    },
    {
      id: '35411598728802570',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B19',
      fullFrontendId: 'Sunset_Plaza/B19',
    },
  ],
};

export const dummyUnits: {
  units: {
    id: string;
    groupFullId: string;
    topFullId: string;
    unitFullId: string;
    fullFrontendId: string;
  }[];
} = {
  units: [
    {
      id: '18510550128694977',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B01',
      unitFullId: 'Country_Corner/B01/Rack_01',
      fullFrontendId: 'Country_Corner/B01/Rack_01',
    },
    {
      id: '20549422368304181',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B01',
      unitFullId: 'Country_Corner/B01/Rack_02',
      fullFrontendId: 'Country_Corner/B01/Rack_02',
    },
    {
      id: '67208029915131260',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B01',
      unitFullId: 'Country_Corner/B01/Rack_03',
      fullFrontendId: 'Country_Corner/B01/Rack_03',
    },
    {
      id: '27545060227891593',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B01',
      unitFullId: 'Country_Corner/B01/Rack_04',
      fullFrontendId: 'Country_Corner/B01/Rack_04',
    },
    {
      id: '60601306731649707',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B01',
      unitFullId: 'Country_Corner/B01/Rack_05',
      fullFrontendId: 'Country_Corner/B01/Rack_05',
    },
    {
      id: '63123832139559368',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B01',
      unitFullId: 'Country_Corner/B01/Rack_06',
      fullFrontendId: 'Country_Corner/B01/Rack_06',
    },
    {
      id: '41944926425762964',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B01',
      unitFullId: 'Country_Corner/B01/Rack_07',
      fullFrontendId: 'Country_Corner/B01/Rack_07',
    },
    {
      id: '24405506703844224',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B01',
      unitFullId: 'Country_Corner/B01/Rack_08',
      fullFrontendId: 'Country_Corner/B01/Rack_08',
    },
    {
      id: '42272127689711786',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B01',
      unitFullId: 'Country_Corner/B01/Rack_09',
      fullFrontendId: 'Country_Corner/B01/Rack_09',
    },
    {
      id: '6471416015895949',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B01',
      unitFullId: 'Country_Corner/B01/Rack_10',
      fullFrontendId: 'Country_Corner/B01/Rack_10',
    },
    {
      id: '53412654243085819',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B02',
      unitFullId: 'Country_Corner/B02/Rack_01',
      fullFrontendId: 'Country_Corner/B02/Rack_01',
    },
    {
      id: '41132362186614864',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B02',
      unitFullId: 'Country_Corner/B02/Rack_02',
      fullFrontendId: 'Country_Corner/B02/Rack_02',
    },
    {
      id: '200804506794335',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B02',
      unitFullId: 'Country_Corner/B02/Rack_03',
      fullFrontendId: 'Country_Corner/B02/Rack_03',
    },
    {
      id: '3005189968530496',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B02',
      unitFullId: 'Country_Corner/B02/Rack_04',
      fullFrontendId: 'Country_Corner/B02/Rack_04',
    },
    {
      id: '22183080308027674',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B02',
      unitFullId: 'Country_Corner/B02/Rack_05',
      fullFrontendId: 'Country_Corner/B02/Rack_05',
    },
    {
      id: '33153032122014401',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B02',
      unitFullId: 'Country_Corner/B02/Rack_06',
      fullFrontendId: 'Country_Corner/B02/Rack_06',
    },
    {
      id: '11384857325292251',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B02',
      unitFullId: 'Country_Corner/B02/Rack_07',
      fullFrontendId: 'Country_Corner/B02/Rack_07',
    },
    {
      id: '53702617871982399',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B02',
      unitFullId: 'Country_Corner/B02/Rack_08',
      fullFrontendId: 'Country_Corner/B02/Rack_08',
    },
    {
      id: '43313190410857714',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B02',
      unitFullId: 'Country_Corner/B02/Rack_09',
      fullFrontendId: 'Country_Corner/B02/Rack_09',
    },
    {
      id: '49587895811009218',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B02',
      unitFullId: 'Country_Corner/B02/Rack_10',
      fullFrontendId: 'Country_Corner/B02/Rack_10',
    },
    {
      id: '49243845264996471',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B03',
      unitFullId: 'Country_Corner/B03/Rack_01',
      fullFrontendId: 'Country_Corner/B03/Rack_01',
    },
    {
      id: '47799741924237567',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B03',
      unitFullId: 'Country_Corner/B03/Rack_02',
      fullFrontendId: 'Country_Corner/B03/Rack_02',
    },
    {
      id: '19546148844086505',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B03',
      unitFullId: 'Country_Corner/B03/Rack_03',
      fullFrontendId: 'Country_Corner/B03/Rack_03',
    },
    {
      id: '12413274228929202',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B03',
      unitFullId: 'Country_Corner/B03/Rack_04',
      fullFrontendId: 'Country_Corner/B03/Rack_04',
    },
    {
      id: '10193385709592867',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B03',
      unitFullId: 'Country_Corner/B03/Rack_05',
      fullFrontendId: 'Country_Corner/B03/Rack_05',
    },
    {
      id: '27325543801546025',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B03',
      unitFullId: 'Country_Corner/B03/Rack_06',
      fullFrontendId: 'Country_Corner/B03/Rack_06',
    },
    {
      id: '25491175176508835',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B03',
      unitFullId: 'Country_Corner/B03/Rack_07',
      fullFrontendId: 'Country_Corner/B03/Rack_07',
    },
    {
      id: '50385604783138722',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B03',
      unitFullId: 'Country_Corner/B03/Rack_08',
      fullFrontendId: 'Country_Corner/B03/Rack_08',
    },
    {
      id: '33421511769530802',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B03',
      unitFullId: 'Country_Corner/B03/Rack_09',
      fullFrontendId: 'Country_Corner/B03/Rack_09',
    },
    {
      id: '29970670436018244',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B03',
      unitFullId: 'Country_Corner/B03/Rack_10',
      fullFrontendId: 'Country_Corner/B03/Rack_10',
    },
    {
      id: '11057815505330630',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B04',
      unitFullId: 'Country_Corner/B04/Rack_01',
      fullFrontendId: 'Country_Corner/B04/Rack_01',
    },
    {
      id: '9964012301718093',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B04',
      unitFullId: 'Country_Corner/B04/Rack_02',
      fullFrontendId: 'Country_Corner/B04/Rack_02',
    },
    {
      id: '68692154953849428',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B04',
      unitFullId: 'Country_Corner/B04/Rack_03',
      fullFrontendId: 'Country_Corner/B04/Rack_03',
    },
    {
      id: '27864213323333659',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B04',
      unitFullId: 'Country_Corner/B04/Rack_04',
      fullFrontendId: 'Country_Corner/B04/Rack_04',
    },
    {
      id: '2251106242537921',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B04',
      unitFullId: 'Country_Corner/B04/Rack_05',
      fullFrontendId: 'Country_Corner/B04/Rack_05',
    },
    {
      id: '42230967664824705',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B04',
      unitFullId: 'Country_Corner/B04/Rack_06',
      fullFrontendId: 'Country_Corner/B04/Rack_06',
    },
    {
      id: '32398600054135596',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B04',
      unitFullId: 'Country_Corner/B04/Rack_07',
      fullFrontendId: 'Country_Corner/B04/Rack_07',
    },
    {
      id: '32228836347571270',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B04',
      unitFullId: 'Country_Corner/B04/Rack_08',
      fullFrontendId: 'Country_Corner/B04/Rack_08',
    },
    {
      id: '43743256505231184',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B04',
      unitFullId: 'Country_Corner/B04/Rack_09',
      fullFrontendId: 'Country_Corner/B04/Rack_09',
    },
    {
      id: '50371792209163583',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B04',
      unitFullId: 'Country_Corner/B04/Rack_10',
      fullFrontendId: 'Country_Corner/B04/Rack_10',
    },
    {
      id: '25873446975477286',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B05',
      unitFullId: 'Country_Corner/B05/Rack_01',
      fullFrontendId: 'Country_Corner/B05/Rack_01',
    },
    {
      id: '15324756511501699',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B05',
      unitFullId: 'Country_Corner/B05/Rack_02',
      fullFrontendId: 'Country_Corner/B05/Rack_02',
    },
    {
      id: '12842385906561425',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B05',
      unitFullId: 'Country_Corner/B05/Rack_03',
      fullFrontendId: 'Country_Corner/B05/Rack_03',
    },
    {
      id: '6754493798219001',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B05',
      unitFullId: 'Country_Corner/B05/Rack_04',
      fullFrontendId: 'Country_Corner/B05/Rack_04',
    },
    {
      id: '46986623740661229',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B05',
      unitFullId: 'Country_Corner/B05/Rack_05',
      fullFrontendId: 'Country_Corner/B05/Rack_05',
    },
    {
      id: '34451422262265380',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B05',
      unitFullId: 'Country_Corner/B05/Rack_06',
      fullFrontendId: 'Country_Corner/B05/Rack_06',
    },
    {
      id: '51228206435257463',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B05',
      unitFullId: 'Country_Corner/B05/Rack_07',
      fullFrontendId: 'Country_Corner/B05/Rack_07',
    },
    {
      id: '60935478022470524',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B05',
      unitFullId: 'Country_Corner/B05/Rack_08',
      fullFrontendId: 'Country_Corner/B05/Rack_08',
    },
    {
      id: '47899254095945171',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B05',
      unitFullId: 'Country_Corner/B05/Rack_09',
      fullFrontendId: 'Country_Corner/B05/Rack_09',
    },
    {
      id: '41766947065356657',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B05',
      unitFullId: 'Country_Corner/B05/Rack_10',
      fullFrontendId: 'Country_Corner/B05/Rack_10',
    },
    {
      id: '5989054454777011',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B06',
      unitFullId: 'Country_Corner/B06/Rack_01',
      fullFrontendId: 'Country_Corner/B06/Rack_01',
    },
    {
      id: '61595418260241589',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B06',
      unitFullId: 'Country_Corner/B06/Rack_02',
      fullFrontendId: 'Country_Corner/B06/Rack_02',
    },
    {
      id: '31987574562642903',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B06',
      unitFullId: 'Country_Corner/B06/Rack_03',
      fullFrontendId: 'Country_Corner/B06/Rack_03',
    },
    {
      id: '12499268189333681',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B06',
      unitFullId: 'Country_Corner/B06/Rack_04',
      fullFrontendId: 'Country_Corner/B06/Rack_04',
    },
    {
      id: '34272712166528836',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B06',
      unitFullId: 'Country_Corner/B06/Rack_05',
      fullFrontendId: 'Country_Corner/B06/Rack_05',
    },
    {
      id: '53228867100884859',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B06',
      unitFullId: 'Country_Corner/B06/Rack_06',
      fullFrontendId: 'Country_Corner/B06/Rack_06',
    },
    {
      id: '52439835487991639',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B06',
      unitFullId: 'Country_Corner/B06/Rack_07',
      fullFrontendId: 'Country_Corner/B06/Rack_07',
    },
    {
      id: '52458105774515491',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B06',
      unitFullId: 'Country_Corner/B06/Rack_08',
      fullFrontendId: 'Country_Corner/B06/Rack_08',
    },
    {
      id: '15939649511646368',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B06',
      unitFullId: 'Country_Corner/B06/Rack_09',
      fullFrontendId: 'Country_Corner/B06/Rack_09',
    },
    {
      id: '18133567724010800',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B06',
      unitFullId: 'Country_Corner/B06/Rack_10',
      fullFrontendId: 'Country_Corner/B06/Rack_10',
    },
    {
      id: '9989473834664962',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B07',
      unitFullId: 'Country_Corner/B07/Rack_01',
      fullFrontendId: 'Country_Corner/B07/Rack_01',
    },
    {
      id: '69618346777589466',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B07',
      unitFullId: 'Country_Corner/B07/Rack_02',
      fullFrontendId: 'Country_Corner/B07/Rack_02',
    },
    {
      id: '14128602983920693',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B07',
      unitFullId: 'Country_Corner/B07/Rack_03',
      fullFrontendId: 'Country_Corner/B07/Rack_03',
    },
    {
      id: '32892454087772485',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B07',
      unitFullId: 'Country_Corner/B07/Rack_04',
      fullFrontendId: 'Country_Corner/B07/Rack_04',
    },
    {
      id: '63377333619320009',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B07',
      unitFullId: 'Country_Corner/B07/Rack_05',
      fullFrontendId: 'Country_Corner/B07/Rack_05',
    },
    {
      id: '35260018520653022',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B07',
      unitFullId: 'Country_Corner/B07/Rack_06',
      fullFrontendId: 'Country_Corner/B07/Rack_06',
    },
    {
      id: '3665309423788960',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B07',
      unitFullId: 'Country_Corner/B07/Rack_07',
      fullFrontendId: 'Country_Corner/B07/Rack_07',
    },
    {
      id: '15352581004808595',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B07',
      unitFullId: 'Country_Corner/B07/Rack_08',
      fullFrontendId: 'Country_Corner/B07/Rack_08',
    },
    {
      id: '35916998317933242',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B07',
      unitFullId: 'Country_Corner/B07/Rack_09',
      fullFrontendId: 'Country_Corner/B07/Rack_09',
    },
    {
      id: '32872391906993377',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B07',
      unitFullId: 'Country_Corner/B07/Rack_10',
      fullFrontendId: 'Country_Corner/B07/Rack_10',
    },
    {
      id: '64544906727223905',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B08',
      unitFullId: 'Country_Corner/B08/Rack_01',
      fullFrontendId: 'Country_Corner/B08/Rack_01',
    },
    {
      id: '23152343014322097',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B08',
      unitFullId: 'Country_Corner/B08/Rack_02',
      fullFrontendId: 'Country_Corner/B08/Rack_02',
    },
    {
      id: '3509739286086225',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B08',
      unitFullId: 'Country_Corner/B08/Rack_03',
      fullFrontendId: 'Country_Corner/B08/Rack_03',
    },
    {
      id: '13317774037895696',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B08',
      unitFullId: 'Country_Corner/B08/Rack_04',
      fullFrontendId: 'Country_Corner/B08/Rack_04',
    },
    {
      id: '57506560893055939',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B08',
      unitFullId: 'Country_Corner/B08/Rack_05',
      fullFrontendId: 'Country_Corner/B08/Rack_05',
    },
    {
      id: '54611592107022391',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B08',
      unitFullId: 'Country_Corner/B08/Rack_06',
      fullFrontendId: 'Country_Corner/B08/Rack_06',
    },
    {
      id: '68194431705816823',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B08',
      unitFullId: 'Country_Corner/B08/Rack_07',
      fullFrontendId: 'Country_Corner/B08/Rack_07',
    },
    {
      id: '65342725437198548',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B08',
      unitFullId: 'Country_Corner/B08/Rack_08',
      fullFrontendId: 'Country_Corner/B08/Rack_08',
    },
    {
      id: '8973983127750483',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B08',
      unitFullId: 'Country_Corner/B08/Rack_09',
      fullFrontendId: 'Country_Corner/B08/Rack_09',
    },
    {
      id: '9163541306821944',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B08',
      unitFullId: 'Country_Corner/B08/Rack_10',
      fullFrontendId: 'Country_Corner/B08/Rack_10',
    },
    {
      id: '61004656969650268',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B09',
      unitFullId: 'Country_Corner/B09/Rack_01',
      fullFrontendId: 'Country_Corner/B09/Rack_01',
    },
    {
      id: '32584793640122762',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B09',
      unitFullId: 'Country_Corner/B09/Rack_02',
      fullFrontendId: 'Country_Corner/B09/Rack_02',
    },
    {
      id: '59449140925314565',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B09',
      unitFullId: 'Country_Corner/B09/Rack_03',
      fullFrontendId: 'Country_Corner/B09/Rack_03',
    },
    {
      id: '68920896432152338',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B09',
      unitFullId: 'Country_Corner/B09/Rack_04',
      fullFrontendId: 'Country_Corner/B09/Rack_04',
    },
    {
      id: '46790268423753599',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B09',
      unitFullId: 'Country_Corner/B09/Rack_05',
      fullFrontendId: 'Country_Corner/B09/Rack_05',
    },
    {
      id: '37874475004350576',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B09',
      unitFullId: 'Country_Corner/B09/Rack_06',
      fullFrontendId: 'Country_Corner/B09/Rack_06',
    },
    {
      id: '2958847841157008',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B09',
      unitFullId: 'Country_Corner/B09/Rack_07',
      fullFrontendId: 'Country_Corner/B09/Rack_07',
    },
    {
      id: '26350145115484613',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B09',
      unitFullId: 'Country_Corner/B09/Rack_08',
      fullFrontendId: 'Country_Corner/B09/Rack_08',
    },
    {
      id: '32718999393037227',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B09',
      unitFullId: 'Country_Corner/B09/Rack_09',
      fullFrontendId: 'Country_Corner/B09/Rack_09',
    },
    {
      id: '50677494698974635',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B09',
      unitFullId: 'Country_Corner/B09/Rack_10',
      fullFrontendId: 'Country_Corner/B09/Rack_10',
    },
    {
      id: '785503921293096',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B10',
      unitFullId: 'Country_Corner/B10/Rack_01',
      fullFrontendId: 'Country_Corner/B10/Rack_01',
    },
    {
      id: '24203669966234050',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B10',
      unitFullId: 'Country_Corner/B10/Rack_02',
      fullFrontendId: 'Country_Corner/B10/Rack_02',
    },
    {
      id: '25429773579953858',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B10',
      unitFullId: 'Country_Corner/B10/Rack_03',
      fullFrontendId: 'Country_Corner/B10/Rack_03',
    },
    {
      id: '32656801140191935',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B10',
      unitFullId: 'Country_Corner/B10/Rack_04',
      fullFrontendId: 'Country_Corner/B10/Rack_04',
    },
    {
      id: '33086645431136950',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B10',
      unitFullId: 'Country_Corner/B10/Rack_05',
      fullFrontendId: 'Country_Corner/B10/Rack_05',
    },
    {
      id: '44821244190917697',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B10',
      unitFullId: 'Country_Corner/B10/Rack_06',
      fullFrontendId: 'Country_Corner/B10/Rack_06',
    },
    {
      id: '15751082509800804',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B10',
      unitFullId: 'Country_Corner/B10/Rack_07',
      fullFrontendId: 'Country_Corner/B10/Rack_07',
    },
    {
      id: '14178622165374584',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B10',
      unitFullId: 'Country_Corner/B10/Rack_08',
      fullFrontendId: 'Country_Corner/B10/Rack_08',
    },
    {
      id: '17881726359928172',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B10',
      unitFullId: 'Country_Corner/B10/Rack_09',
      fullFrontendId: 'Country_Corner/B10/Rack_09',
    },
    {
      id: '32809988975118168',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B10',
      unitFullId: 'Country_Corner/B10/Rack_10',
      fullFrontendId: 'Country_Corner/B10/Rack_10',
    },
    {
      id: '23323314879478550',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B11',
      unitFullId: 'Country_Corner/B11/Rack_01',
      fullFrontendId: 'Country_Corner/B11/Rack_01',
    },
    {
      id: '61365916912849309',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B11',
      unitFullId: 'Country_Corner/B11/Rack_02',
      fullFrontendId: 'Country_Corner/B11/Rack_02',
    },
    {
      id: '23468523451455008',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B11',
      unitFullId: 'Country_Corner/B11/Rack_03',
      fullFrontendId: 'Country_Corner/B11/Rack_03',
    },
    {
      id: '829221139101683',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B11',
      unitFullId: 'Country_Corner/B11/Rack_04',
      fullFrontendId: 'Country_Corner/B11/Rack_04',
    },
    {
      id: '8614138290846856',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B11',
      unitFullId: 'Country_Corner/B11/Rack_05',
      fullFrontendId: 'Country_Corner/B11/Rack_05',
    },
    {
      id: '48818031772887542',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B11',
      unitFullId: 'Country_Corner/B11/Rack_06',
      fullFrontendId: 'Country_Corner/B11/Rack_06',
    },
    {
      id: '20465382959444694',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B11',
      unitFullId: 'Country_Corner/B11/Rack_07',
      fullFrontendId: 'Country_Corner/B11/Rack_07',
    },
    {
      id: '7332170133676183',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B11',
      unitFullId: 'Country_Corner/B11/Rack_08',
      fullFrontendId: 'Country_Corner/B11/Rack_08',
    },
    {
      id: '67551768505398407',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B11',
      unitFullId: 'Country_Corner/B11/Rack_09',
      fullFrontendId: 'Country_Corner/B11/Rack_09',
    },
    {
      id: '21073265830312646',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B11',
      unitFullId: 'Country_Corner/B11/Rack_10',
      fullFrontendId: 'Country_Corner/B11/Rack_10',
    },
    {
      id: '18012315565896238',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B12',
      unitFullId: 'Country_Corner/B12/Rack_01',
      fullFrontendId: 'Country_Corner/B12/Rack_01',
    },
    {
      id: '4096745221330263',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B12',
      unitFullId: 'Country_Corner/B12/Rack_02',
      fullFrontendId: 'Country_Corner/B12/Rack_02',
    },
    {
      id: '14939940098146335',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B12',
      unitFullId: 'Country_Corner/B12/Rack_03',
      fullFrontendId: 'Country_Corner/B12/Rack_03',
    },
    {
      id: '43096600658243782',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B12',
      unitFullId: 'Country_Corner/B12/Rack_04',
      fullFrontendId: 'Country_Corner/B12/Rack_04',
    },
    {
      id: '46968088649331818',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B12',
      unitFullId: 'Country_Corner/B12/Rack_05',
      fullFrontendId: 'Country_Corner/B12/Rack_05',
    },
    {
      id: '6056484481157065',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B12',
      unitFullId: 'Country_Corner/B12/Rack_06',
      fullFrontendId: 'Country_Corner/B12/Rack_06',
    },
    {
      id: '5593354097500761',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B12',
      unitFullId: 'Country_Corner/B12/Rack_07',
      fullFrontendId: 'Country_Corner/B12/Rack_07',
    },
    {
      id: '11827113576427829',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B12',
      unitFullId: 'Country_Corner/B12/Rack_08',
      fullFrontendId: 'Country_Corner/B12/Rack_08',
    },
    {
      id: '69727619634080034',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B12',
      unitFullId: 'Country_Corner/B12/Rack_09',
      fullFrontendId: 'Country_Corner/B12/Rack_09',
    },
    {
      id: '15219950701611155',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B12',
      unitFullId: 'Country_Corner/B12/Rack_10',
      fullFrontendId: 'Country_Corner/B12/Rack_10',
    },
    {
      id: '46452454989978560',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B13',
      unitFullId: 'Country_Corner/B13/Rack_01',
      fullFrontendId: 'Country_Corner/B13/Rack_01',
    },
    {
      id: '69006296838680225',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B13',
      unitFullId: 'Country_Corner/B13/Rack_02',
      fullFrontendId: 'Country_Corner/B13/Rack_02',
    },
    {
      id: '63998850703293741',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B13',
      unitFullId: 'Country_Corner/B13/Rack_03',
      fullFrontendId: 'Country_Corner/B13/Rack_03',
    },
    {
      id: '46949240297145001',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B13',
      unitFullId: 'Country_Corner/B13/Rack_04',
      fullFrontendId: 'Country_Corner/B13/Rack_04',
    },
    {
      id: '399911267441666',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B13',
      unitFullId: 'Country_Corner/B13/Rack_05',
      fullFrontendId: 'Country_Corner/B13/Rack_05',
    },
    {
      id: '48619095513868517',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B13',
      unitFullId: 'Country_Corner/B13/Rack_06',
      fullFrontendId: 'Country_Corner/B13/Rack_06',
    },
    {
      id: '34768599284165404',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B13',
      unitFullId: 'Country_Corner/B13/Rack_07',
      fullFrontendId: 'Country_Corner/B13/Rack_07',
    },
    {
      id: '56653590783418914',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B13',
      unitFullId: 'Country_Corner/B13/Rack_08',
      fullFrontendId: 'Country_Corner/B13/Rack_08',
    },
    {
      id: '69842489705839361',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B13',
      unitFullId: 'Country_Corner/B13/Rack_09',
      fullFrontendId: 'Country_Corner/B13/Rack_09',
    },
    {
      id: '57550393130509657',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B13',
      unitFullId: 'Country_Corner/B13/Rack_10',
      fullFrontendId: 'Country_Corner/B13/Rack_10',
    },
    {
      id: '45297514382031054',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B14',
      unitFullId: 'Country_Corner/B14/Rack_01',
      fullFrontendId: 'Country_Corner/B14/Rack_01',
    },
    {
      id: '62503218827957649',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B14',
      unitFullId: 'Country_Corner/B14/Rack_02',
      fullFrontendId: 'Country_Corner/B14/Rack_02',
    },
    {
      id: '29245221879371902',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B14',
      unitFullId: 'Country_Corner/B14/Rack_03',
      fullFrontendId: 'Country_Corner/B14/Rack_03',
    },
    {
      id: '2050947959828042',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B14',
      unitFullId: 'Country_Corner/B14/Rack_04',
      fullFrontendId: 'Country_Corner/B14/Rack_04',
    },
    {
      id: '67770605905027679',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B14',
      unitFullId: 'Country_Corner/B14/Rack_05',
      fullFrontendId: 'Country_Corner/B14/Rack_05',
    },
    {
      id: '25632963672790656',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B14',
      unitFullId: 'Country_Corner/B14/Rack_06',
      fullFrontendId: 'Country_Corner/B14/Rack_06',
    },
    {
      id: '25111777456411057',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B14',
      unitFullId: 'Country_Corner/B14/Rack_07',
      fullFrontendId: 'Country_Corner/B14/Rack_07',
    },
    {
      id: '776486031583367',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B14',
      unitFullId: 'Country_Corner/B14/Rack_08',
      fullFrontendId: 'Country_Corner/B14/Rack_08',
    },
    {
      id: '9185293464686176',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B14',
      unitFullId: 'Country_Corner/B14/Rack_09',
      fullFrontendId: 'Country_Corner/B14/Rack_09',
    },
    {
      id: '20307605857058898',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B14',
      unitFullId: 'Country_Corner/B14/Rack_10',
      fullFrontendId: 'Country_Corner/B14/Rack_10',
    },
    {
      id: '53051536248505854',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B15',
      unitFullId: 'Country_Corner/B15/Rack_01',
      fullFrontendId: 'Country_Corner/B15/Rack_01',
    },
    {
      id: '16613706757810192',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B15',
      unitFullId: 'Country_Corner/B15/Rack_02',
      fullFrontendId: 'Country_Corner/B15/Rack_02',
    },
    {
      id: '62620663632847641',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B15',
      unitFullId: 'Country_Corner/B15/Rack_03',
      fullFrontendId: 'Country_Corner/B15/Rack_03',
    },
    {
      id: '10689697607974890',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B15',
      unitFullId: 'Country_Corner/B15/Rack_04',
      fullFrontendId: 'Country_Corner/B15/Rack_04',
    },
    {
      id: '55330563590153514',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B15',
      unitFullId: 'Country_Corner/B15/Rack_05',
      fullFrontendId: 'Country_Corner/B15/Rack_05',
    },
    {
      id: '9700019772627367',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B15',
      unitFullId: 'Country_Corner/B15/Rack_06',
      fullFrontendId: 'Country_Corner/B15/Rack_06',
    },
    {
      id: '70032675825587218',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B15',
      unitFullId: 'Country_Corner/B15/Rack_07',
      fullFrontendId: 'Country_Corner/B15/Rack_07',
    },
    {
      id: '2116836727674663',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B15',
      unitFullId: 'Country_Corner/B15/Rack_08',
      fullFrontendId: 'Country_Corner/B15/Rack_08',
    },
    {
      id: '18915650254211359',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B15',
      unitFullId: 'Country_Corner/B15/Rack_09',
      fullFrontendId: 'Country_Corner/B15/Rack_09',
    },
    {
      id: '64661473704722937',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B15',
      unitFullId: 'Country_Corner/B15/Rack_10',
      fullFrontendId: 'Country_Corner/B15/Rack_10',
    },
    {
      id: '49108634764414873',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B16',
      unitFullId: 'Country_Corner/B16/Rack_01',
      fullFrontendId: 'Country_Corner/B16/Rack_01',
    },
    {
      id: '35889711615253138',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B16',
      unitFullId: 'Country_Corner/B16/Rack_02',
      fullFrontendId: 'Country_Corner/B16/Rack_02',
    },
    {
      id: '12413331974127915',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B16',
      unitFullId: 'Country_Corner/B16/Rack_03',
      fullFrontendId: 'Country_Corner/B16/Rack_03',
    },
    {
      id: '67830636093593716',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B16',
      unitFullId: 'Country_Corner/B16/Rack_04',
      fullFrontendId: 'Country_Corner/B16/Rack_04',
    },
    {
      id: '18592466168668586',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B16',
      unitFullId: 'Country_Corner/B16/Rack_05',
      fullFrontendId: 'Country_Corner/B16/Rack_05',
    },
    {
      id: '17858253888497353',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B16',
      unitFullId: 'Country_Corner/B16/Rack_06',
      fullFrontendId: 'Country_Corner/B16/Rack_06',
    },
    {
      id: '71012265472545572',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B16',
      unitFullId: 'Country_Corner/B16/Rack_07',
      fullFrontendId: 'Country_Corner/B16/Rack_07',
    },
    {
      id: '14465267306586943',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B16',
      unitFullId: 'Country_Corner/B16/Rack_08',
      fullFrontendId: 'Country_Corner/B16/Rack_08',
    },
    {
      id: '30706446729201059',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B16',
      unitFullId: 'Country_Corner/B16/Rack_09',
      fullFrontendId: 'Country_Corner/B16/Rack_09',
    },
    {
      id: '4820068605217853',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B16',
      unitFullId: 'Country_Corner/B16/Rack_10',
      fullFrontendId: 'Country_Corner/B16/Rack_10',
    },
    {
      id: '52142253395025605',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B17',
      unitFullId: 'Country_Corner/B17/Rack_01',
      fullFrontendId: 'Country_Corner/B17/Rack_01',
    },
    {
      id: '20333699900798398',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B17',
      unitFullId: 'Country_Corner/B17/Rack_02',
      fullFrontendId: 'Country_Corner/B17/Rack_02',
    },
    {
      id: '61698682213406551',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B17',
      unitFullId: 'Country_Corner/B17/Rack_03',
      fullFrontendId: 'Country_Corner/B17/Rack_03',
    },
    {
      id: '22258116000080408',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B17',
      unitFullId: 'Country_Corner/B17/Rack_04',
      fullFrontendId: 'Country_Corner/B17/Rack_04',
    },
    {
      id: '2687068079496498',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B17',
      unitFullId: 'Country_Corner/B17/Rack_05',
      fullFrontendId: 'Country_Corner/B17/Rack_05',
    },
    {
      id: '4090001669242293',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B17',
      unitFullId: 'Country_Corner/B17/Rack_06',
      fullFrontendId: 'Country_Corner/B17/Rack_06',
    },
    {
      id: '21750137908642234',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B17',
      unitFullId: 'Country_Corner/B17/Rack_07',
      fullFrontendId: 'Country_Corner/B17/Rack_07',
    },
    {
      id: '7497721837416599',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B17',
      unitFullId: 'Country_Corner/B17/Rack_08',
      fullFrontendId: 'Country_Corner/B17/Rack_08',
    },
    {
      id: '67536427088638350',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B17',
      unitFullId: 'Country_Corner/B17/Rack_09',
      fullFrontendId: 'Country_Corner/B17/Rack_09',
    },
    {
      id: '56988802654745276',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B17',
      unitFullId: 'Country_Corner/B17/Rack_10',
      fullFrontendId: 'Country_Corner/B17/Rack_10',
    },
    {
      id: '70853358094367588',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B18',
      unitFullId: 'Country_Corner/B18/Rack_01',
      fullFrontendId: 'Country_Corner/B18/Rack_01',
    },
    {
      id: '22159651839929015',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B18',
      unitFullId: 'Country_Corner/B18/Rack_02',
      fullFrontendId: 'Country_Corner/B18/Rack_02',
    },
    {
      id: '61807720426445642',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B18',
      unitFullId: 'Country_Corner/B18/Rack_03',
      fullFrontendId: 'Country_Corner/B18/Rack_03',
    },
    {
      id: '41149068504866849',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B18',
      unitFullId: 'Country_Corner/B18/Rack_04',
      fullFrontendId: 'Country_Corner/B18/Rack_04',
    },
    {
      id: '35872618282645831',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B18',
      unitFullId: 'Country_Corner/B18/Rack_05',
      fullFrontendId: 'Country_Corner/B18/Rack_05',
    },
    {
      id: '37450924689339264',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B18',
      unitFullId: 'Country_Corner/B18/Rack_06',
      fullFrontendId: 'Country_Corner/B18/Rack_06',
    },
    {
      id: '57970417146406091',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B18',
      unitFullId: 'Country_Corner/B18/Rack_07',
      fullFrontendId: 'Country_Corner/B18/Rack_07',
    },
    {
      id: '56908883118135827',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B18',
      unitFullId: 'Country_Corner/B18/Rack_08',
      fullFrontendId: 'Country_Corner/B18/Rack_08',
    },
    {
      id: '66615624213342415',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B18',
      unitFullId: 'Country_Corner/B18/Rack_09',
      fullFrontendId: 'Country_Corner/B18/Rack_09',
    },
    {
      id: '65081736682430764',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B18',
      unitFullId: 'Country_Corner/B18/Rack_10',
      fullFrontendId: 'Country_Corner/B18/Rack_10',
    },
    {
      id: '41016897833360183',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B19',
      unitFullId: 'Country_Corner/B19/Rack_01',
      fullFrontendId: 'Country_Corner/B19/Rack_01',
    },
    {
      id: '59330341324369333',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B19',
      unitFullId: 'Country_Corner/B19/Rack_02',
      fullFrontendId: 'Country_Corner/B19/Rack_02',
    },
    {
      id: '40970096715439578',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B19',
      unitFullId: 'Country_Corner/B19/Rack_03',
      fullFrontendId: 'Country_Corner/B19/Rack_03',
    },
    {
      id: '41922314307811273',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B19',
      unitFullId: 'Country_Corner/B19/Rack_04',
      fullFrontendId: 'Country_Corner/B19/Rack_04',
    },
    {
      id: '2026255838254836',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B19',
      unitFullId: 'Country_Corner/B19/Rack_05',
      fullFrontendId: 'Country_Corner/B19/Rack_05',
    },
    {
      id: '51865357333988480',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B19',
      unitFullId: 'Country_Corner/B19/Rack_06',
      fullFrontendId: 'Country_Corner/B19/Rack_06',
    },
    {
      id: '6277603696836004',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B19',
      unitFullId: 'Country_Corner/B19/Rack_07',
      fullFrontendId: 'Country_Corner/B19/Rack_07',
    },
    {
      id: '39160585113044302',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B19',
      unitFullId: 'Country_Corner/B19/Rack_08',
      fullFrontendId: 'Country_Corner/B19/Rack_08',
    },
    {
      id: '15525746307216519',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B19',
      unitFullId: 'Country_Corner/B19/Rack_09',
      fullFrontendId: 'Country_Corner/B19/Rack_09',
    },
    {
      id: '13750238921869415',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B19',
      unitFullId: 'Country_Corner/B19/Rack_10',
      fullFrontendId: 'Country_Corner/B19/Rack_10',
    },
    {
      id: '573834764319158',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B20',
      unitFullId: 'Country_Corner/B20/Rack_01',
      fullFrontendId: 'Country_Corner/B20/Rack_01',
    },
    {
      id: '15649704207484200',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B20',
      unitFullId: 'Country_Corner/B20/Rack_02',
      fullFrontendId: 'Country_Corner/B20/Rack_02',
    },
    {
      id: '66087345753916469',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B20',
      unitFullId: 'Country_Corner/B20/Rack_03',
      fullFrontendId: 'Country_Corner/B20/Rack_03',
    },
    {
      id: '34937527639391239',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B20',
      unitFullId: 'Country_Corner/B20/Rack_04',
      fullFrontendId: 'Country_Corner/B20/Rack_04',
    },
    {
      id: '17562350934547220',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B20',
      unitFullId: 'Country_Corner/B20/Rack_05',
      fullFrontendId: 'Country_Corner/B20/Rack_05',
    },
    {
      id: '20795102937643068',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B20',
      unitFullId: 'Country_Corner/B20/Rack_06',
      fullFrontendId: 'Country_Corner/B20/Rack_06',
    },
    {
      id: '1625159942916716',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B20',
      unitFullId: 'Country_Corner/B20/Rack_07',
      fullFrontendId: 'Country_Corner/B20/Rack_07',
    },
    {
      id: '29545554138899483',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B20',
      unitFullId: 'Country_Corner/B20/Rack_08',
      fullFrontendId: 'Country_Corner/B20/Rack_08',
    },
    {
      id: '35814042208166959',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B20',
      unitFullId: 'Country_Corner/B20/Rack_09',
      fullFrontendId: 'Country_Corner/B20/Rack_09',
    },
    {
      id: '51261903590874457',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B20',
      unitFullId: 'Country_Corner/B20/Rack_10',
      fullFrontendId: 'Country_Corner/B20/Rack_10',
    },
    {
      id: '52187848566817573',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B21',
      unitFullId: 'Country_Corner/B21/Rack_01',
      fullFrontendId: 'Country_Corner/B21/Rack_01',
    },
    {
      id: '27170204668173644',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B21',
      unitFullId: 'Country_Corner/B21/Rack_02',
      fullFrontendId: 'Country_Corner/B21/Rack_02',
    },
    {
      id: '6204771740522162',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B21',
      unitFullId: 'Country_Corner/B21/Rack_03',
      fullFrontendId: 'Country_Corner/B21/Rack_03',
    },
    {
      id: '20906450787144733',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B21',
      unitFullId: 'Country_Corner/B21/Rack_04',
      fullFrontendId: 'Country_Corner/B21/Rack_04',
    },
    {
      id: '56701931486759686',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B21',
      unitFullId: 'Country_Corner/B21/Rack_05',
      fullFrontendId: 'Country_Corner/B21/Rack_05',
    },
    {
      id: '39562889667935613',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B21',
      unitFullId: 'Country_Corner/B21/Rack_06',
      fullFrontendId: 'Country_Corner/B21/Rack_06',
    },
    {
      id: '53494161462184094',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B21',
      unitFullId: 'Country_Corner/B21/Rack_07',
      fullFrontendId: 'Country_Corner/B21/Rack_07',
    },
    {
      id: '34966689709591649',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B21',
      unitFullId: 'Country_Corner/B21/Rack_08',
      fullFrontendId: 'Country_Corner/B21/Rack_08',
    },
    {
      id: '31046135398117221',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B21',
      unitFullId: 'Country_Corner/B21/Rack_09',
      fullFrontendId: 'Country_Corner/B21/Rack_09',
    },
    {
      id: '39957277760540041',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B21',
      unitFullId: 'Country_Corner/B21/Rack_10',
      fullFrontendId: 'Country_Corner/B21/Rack_10',
    },
    {
      id: '9183437896062067',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B22',
      unitFullId: 'Country_Corner/B22/Rack_01',
      fullFrontendId: 'Country_Corner/B22/Rack_01',
    },
    {
      id: '61750720480460367',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B22',
      unitFullId: 'Country_Corner/B22/Rack_02',
      fullFrontendId: 'Country_Corner/B22/Rack_02',
    },
    {
      id: '5009413002640889',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B22',
      unitFullId: 'Country_Corner/B22/Rack_03',
      fullFrontendId: 'Country_Corner/B22/Rack_03',
    },
    {
      id: '10439670912067822',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B22',
      unitFullId: 'Country_Corner/B22/Rack_04',
      fullFrontendId: 'Country_Corner/B22/Rack_04',
    },
    {
      id: '37633342627217530',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B22',
      unitFullId: 'Country_Corner/B22/Rack_05',
      fullFrontendId: 'Country_Corner/B22/Rack_05',
    },
    {
      id: '15652258410448933',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B22',
      unitFullId: 'Country_Corner/B22/Rack_06',
      fullFrontendId: 'Country_Corner/B22/Rack_06',
    },
    {
      id: '29853818218223332',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B22',
      unitFullId: 'Country_Corner/B22/Rack_07',
      fullFrontendId: 'Country_Corner/B22/Rack_07',
    },
    {
      id: '62893054815165414',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B22',
      unitFullId: 'Country_Corner/B22/Rack_08',
      fullFrontendId: 'Country_Corner/B22/Rack_08',
    },
    {
      id: '10163183405473968',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B22',
      unitFullId: 'Country_Corner/B22/Rack_09',
      fullFrontendId: 'Country_Corner/B22/Rack_09',
    },
    {
      id: '49400842981247887',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B22',
      unitFullId: 'Country_Corner/B22/Rack_10',
      fullFrontendId: 'Country_Corner/B22/Rack_10',
    },
    {
      id: '62550064869972480',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B23',
      unitFullId: 'Country_Corner/B23/Rack_01',
      fullFrontendId: 'Country_Corner/B23/Rack_01',
    },
    {
      id: '29724370716367113',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B23',
      unitFullId: 'Country_Corner/B23/Rack_02',
      fullFrontendId: 'Country_Corner/B23/Rack_02',
    },
    {
      id: '1610670103853015',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B23',
      unitFullId: 'Country_Corner/B23/Rack_03',
      fullFrontendId: 'Country_Corner/B23/Rack_03',
    },
    {
      id: '69369577755331986',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B23',
      unitFullId: 'Country_Corner/B23/Rack_04',
      fullFrontendId: 'Country_Corner/B23/Rack_04',
    },
    {
      id: '57639174054994672',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B23',
      unitFullId: 'Country_Corner/B23/Rack_05',
      fullFrontendId: 'Country_Corner/B23/Rack_05',
    },
    {
      id: '67365459092375554',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B23',
      unitFullId: 'Country_Corner/B23/Rack_06',
      fullFrontendId: 'Country_Corner/B23/Rack_06',
    },
    {
      id: '32689711467471291',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B23',
      unitFullId: 'Country_Corner/B23/Rack_07',
      fullFrontendId: 'Country_Corner/B23/Rack_07',
    },
    {
      id: '6978883631691550',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B23',
      unitFullId: 'Country_Corner/B23/Rack_08',
      fullFrontendId: 'Country_Corner/B23/Rack_08',
    },
    {
      id: '38305957045744950',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B23',
      unitFullId: 'Country_Corner/B23/Rack_09',
      fullFrontendId: 'Country_Corner/B23/Rack_09',
    },
    {
      id: '68114984296474538',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B23',
      unitFullId: 'Country_Corner/B23/Rack_10',
      fullFrontendId: 'Country_Corner/B23/Rack_10',
    },
    {
      id: '17201046990530016',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B24',
      unitFullId: 'Country_Corner/B24/Rack_01',
      fullFrontendId: 'Country_Corner/B24/Rack_01',
    },
    {
      id: '61434457278327309',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B24',
      unitFullId: 'Country_Corner/B24/Rack_02',
      fullFrontendId: 'Country_Corner/B24/Rack_02',
    },
    {
      id: '27400757141998347',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B24',
      unitFullId: 'Country_Corner/B24/Rack_03',
      fullFrontendId: 'Country_Corner/B24/Rack_03',
    },
    {
      id: '20110464637511486',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B24',
      unitFullId: 'Country_Corner/B24/Rack_04',
      fullFrontendId: 'Country_Corner/B24/Rack_04',
    },
    {
      id: '45041541419960412',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B24',
      unitFullId: 'Country_Corner/B24/Rack_05',
      fullFrontendId: 'Country_Corner/B24/Rack_05',
    },
    {
      id: '66839987110890160',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B24',
      unitFullId: 'Country_Corner/B24/Rack_06',
      fullFrontendId: 'Country_Corner/B24/Rack_06',
    },
    {
      id: '34546484587110454',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B24',
      unitFullId: 'Country_Corner/B24/Rack_07',
      fullFrontendId: 'Country_Corner/B24/Rack_07',
    },
    {
      id: '52855507319075531',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B24',
      unitFullId: 'Country_Corner/B24/Rack_08',
      fullFrontendId: 'Country_Corner/B24/Rack_08',
    },
    {
      id: '31085199199260777',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B24',
      unitFullId: 'Country_Corner/B24/Rack_09',
      fullFrontendId: 'Country_Corner/B24/Rack_09',
    },
    {
      id: '50712416082944508',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B24',
      unitFullId: 'Country_Corner/B24/Rack_10',
      fullFrontendId: 'Country_Corner/B24/Rack_10',
    },
    {
      id: '24504887961452069',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B25',
      unitFullId: 'Country_Corner/B25/Rack_01',
      fullFrontendId: 'Country_Corner/B25/Rack_01',
    },
    {
      id: '28117427348915420',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B25',
      unitFullId: 'Country_Corner/B25/Rack_02',
      fullFrontendId: 'Country_Corner/B25/Rack_02',
    },
    {
      id: '6958246851868558',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B25',
      unitFullId: 'Country_Corner/B25/Rack_03',
      fullFrontendId: 'Country_Corner/B25/Rack_03',
    },
    {
      id: '2954543959903114',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B25',
      unitFullId: 'Country_Corner/B25/Rack_04',
      fullFrontendId: 'Country_Corner/B25/Rack_04',
    },
    {
      id: '6540304199980755',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B25',
      unitFullId: 'Country_Corner/B25/Rack_05',
      fullFrontendId: 'Country_Corner/B25/Rack_05',
    },
    {
      id: '47665735283617424',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B25',
      unitFullId: 'Country_Corner/B25/Rack_06',
      fullFrontendId: 'Country_Corner/B25/Rack_06',
    },
    {
      id: '69095184924677916',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B25',
      unitFullId: 'Country_Corner/B25/Rack_07',
      fullFrontendId: 'Country_Corner/B25/Rack_07',
    },
    {
      id: '24121244713338821',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B25',
      unitFullId: 'Country_Corner/B25/Rack_08',
      fullFrontendId: 'Country_Corner/B25/Rack_08',
    },
    {
      id: '6429553694724504',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B25',
      unitFullId: 'Country_Corner/B25/Rack_09',
      fullFrontendId: 'Country_Corner/B25/Rack_09',
    },
    {
      id: '2435862662525847',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B25',
      unitFullId: 'Country_Corner/B25/Rack_10',
      fullFrontendId: 'Country_Corner/B25/Rack_10',
    },
    {
      id: '14581783459110500',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B26',
      unitFullId: 'Country_Corner/B26/Rack_01',
      fullFrontendId: 'Country_Corner/B26/Rack_01',
    },
    {
      id: '59395084066388735',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B26',
      unitFullId: 'Country_Corner/B26/Rack_02',
      fullFrontendId: 'Country_Corner/B26/Rack_02',
    },
    {
      id: '17852576880260495',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B26',
      unitFullId: 'Country_Corner/B26/Rack_03',
      fullFrontendId: 'Country_Corner/B26/Rack_03',
    },
    {
      id: '32790652432554140',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B26',
      unitFullId: 'Country_Corner/B26/Rack_04',
      fullFrontendId: 'Country_Corner/B26/Rack_04',
    },
    {
      id: '61659681451544347',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B26',
      unitFullId: 'Country_Corner/B26/Rack_05',
      fullFrontendId: 'Country_Corner/B26/Rack_05',
    },
    {
      id: '40969798542131576',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B26',
      unitFullId: 'Country_Corner/B26/Rack_06',
      fullFrontendId: 'Country_Corner/B26/Rack_06',
    },
    {
      id: '22596396457745528',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B26',
      unitFullId: 'Country_Corner/B26/Rack_07',
      fullFrontendId: 'Country_Corner/B26/Rack_07',
    },
    {
      id: '56079652480746013',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B26',
      unitFullId: 'Country_Corner/B26/Rack_08',
      fullFrontendId: 'Country_Corner/B26/Rack_08',
    },
    {
      id: '10010385498247626',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B26',
      unitFullId: 'Country_Corner/B26/Rack_09',
      fullFrontendId: 'Country_Corner/B26/Rack_09',
    },
    {
      id: '30388637531089197',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B26',
      unitFullId: 'Country_Corner/B26/Rack_10',
      fullFrontendId: 'Country_Corner/B26/Rack_10',
    },
    {
      id: '67656174610726294',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B27',
      unitFullId: 'Country_Corner/B27/Rack_01',
      fullFrontendId: 'Country_Corner/B27/Rack_01',
    },
    {
      id: '4061514289691207',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B27',
      unitFullId: 'Country_Corner/B27/Rack_02',
      fullFrontendId: 'Country_Corner/B27/Rack_02',
    },
    {
      id: '36354892003688144',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B27',
      unitFullId: 'Country_Corner/B27/Rack_03',
      fullFrontendId: 'Country_Corner/B27/Rack_03',
    },
    {
      id: '32471773617279006',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B27',
      unitFullId: 'Country_Corner/B27/Rack_04',
      fullFrontendId: 'Country_Corner/B27/Rack_04',
    },
    {
      id: '28545074712574921',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B27',
      unitFullId: 'Country_Corner/B27/Rack_05',
      fullFrontendId: 'Country_Corner/B27/Rack_05',
    },
    {
      id: '53237918646524405',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B27',
      unitFullId: 'Country_Corner/B27/Rack_06',
      fullFrontendId: 'Country_Corner/B27/Rack_06',
    },
    {
      id: '48661999858345633',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B27',
      unitFullId: 'Country_Corner/B27/Rack_07',
      fullFrontendId: 'Country_Corner/B27/Rack_07',
    },
    {
      id: '35017299569429283',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B27',
      unitFullId: 'Country_Corner/B27/Rack_08',
      fullFrontendId: 'Country_Corner/B27/Rack_08',
    },
    {
      id: '70410253746328374',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B27',
      unitFullId: 'Country_Corner/B27/Rack_09',
      fullFrontendId: 'Country_Corner/B27/Rack_09',
    },
    {
      id: '46976829218980256',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B27',
      unitFullId: 'Country_Corner/B27/Rack_10',
      fullFrontendId: 'Country_Corner/B27/Rack_10',
    },
    {
      id: '15990764837004244',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B28',
      unitFullId: 'Country_Corner/B28/Rack_01',
      fullFrontendId: 'Country_Corner/B28/Rack_01',
    },
    {
      id: '43457394153082489',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B28',
      unitFullId: 'Country_Corner/B28/Rack_02',
      fullFrontendId: 'Country_Corner/B28/Rack_02',
    },
    {
      id: '13471351640558659',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B28',
      unitFullId: 'Country_Corner/B28/Rack_03',
      fullFrontendId: 'Country_Corner/B28/Rack_03',
    },
    {
      id: '43257018117311641',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B28',
      unitFullId: 'Country_Corner/B28/Rack_04',
      fullFrontendId: 'Country_Corner/B28/Rack_04',
    },
    {
      id: '44441210032859093',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B28',
      unitFullId: 'Country_Corner/B28/Rack_05',
      fullFrontendId: 'Country_Corner/B28/Rack_05',
    },
    {
      id: '56809198314856746',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B28',
      unitFullId: 'Country_Corner/B28/Rack_06',
      fullFrontendId: 'Country_Corner/B28/Rack_06',
    },
    {
      id: '52892527099087293',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B28',
      unitFullId: 'Country_Corner/B28/Rack_07',
      fullFrontendId: 'Country_Corner/B28/Rack_07',
    },
    {
      id: '1517276912271249',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B28',
      unitFullId: 'Country_Corner/B28/Rack_08',
      fullFrontendId: 'Country_Corner/B28/Rack_08',
    },
    {
      id: '642901347155358',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B28',
      unitFullId: 'Country_Corner/B28/Rack_09',
      fullFrontendId: 'Country_Corner/B28/Rack_09',
    },
    {
      id: '16728424670061118',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B28',
      unitFullId: 'Country_Corner/B28/Rack_10',
      fullFrontendId: 'Country_Corner/B28/Rack_10',
    },
    {
      id: '46434595840970237',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B29',
      unitFullId: 'Country_Corner/B29/Rack_01',
      fullFrontendId: 'Country_Corner/B29/Rack_01',
    },
    {
      id: '38611058194173256',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B29',
      unitFullId: 'Country_Corner/B29/Rack_02',
      fullFrontendId: 'Country_Corner/B29/Rack_02',
    },
    {
      id: '70046936809406829',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B29',
      unitFullId: 'Country_Corner/B29/Rack_03',
      fullFrontendId: 'Country_Corner/B29/Rack_03',
    },
    {
      id: '18076209839280849',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B29',
      unitFullId: 'Country_Corner/B29/Rack_04',
      fullFrontendId: 'Country_Corner/B29/Rack_04',
    },
    {
      id: '54733539380796709',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B29',
      unitFullId: 'Country_Corner/B29/Rack_05',
      fullFrontendId: 'Country_Corner/B29/Rack_05',
    },
    {
      id: '37167083848744828',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B29',
      unitFullId: 'Country_Corner/B29/Rack_06',
      fullFrontendId: 'Country_Corner/B29/Rack_06',
    },
    {
      id: '35197177310155977',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B29',
      unitFullId: 'Country_Corner/B29/Rack_07',
      fullFrontendId: 'Country_Corner/B29/Rack_07',
    },
    {
      id: '69588550128907886',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B29',
      unitFullId: 'Country_Corner/B29/Rack_08',
      fullFrontendId: 'Country_Corner/B29/Rack_08',
    },
    {
      id: '54987447907194742',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B29',
      unitFullId: 'Country_Corner/B29/Rack_09',
      fullFrontendId: 'Country_Corner/B29/Rack_09',
    },
    {
      id: '22959367894914781',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B29',
      unitFullId: 'Country_Corner/B29/Rack_10',
      fullFrontendId: 'Country_Corner/B29/Rack_10',
    },
    {
      id: '54426466015475921',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B30',
      unitFullId: 'Country_Corner/B30/Rack_01',
      fullFrontendId: 'Country_Corner/B30/Rack_01',
    },
    {
      id: '769405584894263',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B30',
      unitFullId: 'Country_Corner/B30/Rack_02',
      fullFrontendId: 'Country_Corner/B30/Rack_02',
    },
    {
      id: '44604054646835931',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B30',
      unitFullId: 'Country_Corner/B30/Rack_03',
      fullFrontendId: 'Country_Corner/B30/Rack_03',
    },
    {
      id: '12242169608091269',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B30',
      unitFullId: 'Country_Corner/B30/Rack_04',
      fullFrontendId: 'Country_Corner/B30/Rack_04',
    },
    {
      id: '60137551809065668',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B30',
      unitFullId: 'Country_Corner/B30/Rack_05',
      fullFrontendId: 'Country_Corner/B30/Rack_05',
    },
    {
      id: '49907290519630689',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B30',
      unitFullId: 'Country_Corner/B30/Rack_06',
      fullFrontendId: 'Country_Corner/B30/Rack_06',
    },
    {
      id: '39521135278296569',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B30',
      unitFullId: 'Country_Corner/B30/Rack_07',
      fullFrontendId: 'Country_Corner/B30/Rack_07',
    },
    {
      id: '45762990185226657',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B30',
      unitFullId: 'Country_Corner/B30/Rack_08',
      fullFrontendId: 'Country_Corner/B30/Rack_08',
    },
    {
      id: '40376310974477272',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B30',
      unitFullId: 'Country_Corner/B30/Rack_09',
      fullFrontendId: 'Country_Corner/B30/Rack_09',
    },
    {
      id: '11931954233655033',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B30',
      unitFullId: 'Country_Corner/B30/Rack_10',
      fullFrontendId: 'Country_Corner/B30/Rack_10',
    },
    {
      id: '3516879690624759',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B31',
      unitFullId: 'Country_Corner/B31/Rack_01',
      fullFrontendId: 'Country_Corner/B31/Rack_01',
    },
    {
      id: '36314423494654061',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B31',
      unitFullId: 'Country_Corner/B31/Rack_02',
      fullFrontendId: 'Country_Corner/B31/Rack_02',
    },
    {
      id: '23741111991284011',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B31',
      unitFullId: 'Country_Corner/B31/Rack_03',
      fullFrontendId: 'Country_Corner/B31/Rack_03',
    },
    {
      id: '36562173920921604',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B31',
      unitFullId: 'Country_Corner/B31/Rack_04',
      fullFrontendId: 'Country_Corner/B31/Rack_04',
    },
    {
      id: '20595154266960448',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B31',
      unitFullId: 'Country_Corner/B31/Rack_05',
      fullFrontendId: 'Country_Corner/B31/Rack_05',
    },
    {
      id: '42577330539636526',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B31',
      unitFullId: 'Country_Corner/B31/Rack_06',
      fullFrontendId: 'Country_Corner/B31/Rack_06',
    },
    {
      id: '13713968915224737',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B31',
      unitFullId: 'Country_Corner/B31/Rack_07',
      fullFrontendId: 'Country_Corner/B31/Rack_07',
    },
    {
      id: '27927971759830067',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B31',
      unitFullId: 'Country_Corner/B31/Rack_08',
      fullFrontendId: 'Country_Corner/B31/Rack_08',
    },
    {
      id: '52491862310218294',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B31',
      unitFullId: 'Country_Corner/B31/Rack_09',
      fullFrontendId: 'Country_Corner/B31/Rack_09',
    },
    {
      id: '35059889886841900',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B31',
      unitFullId: 'Country_Corner/B31/Rack_10',
      fullFrontendId: 'Country_Corner/B31/Rack_10',
    },
    {
      id: '44262786570105247',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B01',
      unitFullId: 'Smart_Hill/B01/Rack_01',
      fullFrontendId: 'Smart_Hill/B01/Rack_01',
    },
    {
      id: '26905524237387724',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B01',
      unitFullId: 'Smart_Hill/B01/Rack_02',
      fullFrontendId: 'Smart_Hill/B01/Rack_02',
    },
    {
      id: '43266919750272151',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B01',
      unitFullId: 'Smart_Hill/B01/Rack_03',
      fullFrontendId: 'Smart_Hill/B01/Rack_03',
    },
    {
      id: '59086561782369494',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B01',
      unitFullId: 'Smart_Hill/B01/Rack_04',
      fullFrontendId: 'Smart_Hill/B01/Rack_04',
    },
    {
      id: '4655539236530224',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B01',
      unitFullId: 'Smart_Hill/B01/Rack_05',
      fullFrontendId: 'Smart_Hill/B01/Rack_05',
    },
    {
      id: '66684427417835148',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B01',
      unitFullId: 'Smart_Hill/B01/Rack_06',
      fullFrontendId: 'Smart_Hill/B01/Rack_06',
    },
    {
      id: '44378986949131962',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B01',
      unitFullId: 'Smart_Hill/B01/Rack_07',
      fullFrontendId: 'Smart_Hill/B01/Rack_07',
    },
    {
      id: '6235619112861210',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B02',
      unitFullId: 'Smart_Hill/B02/Rack_01',
      fullFrontendId: 'Smart_Hill/B02/Rack_01',
    },
    {
      id: '32005371243043353',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B02',
      unitFullId: 'Smart_Hill/B02/Rack_02',
      fullFrontendId: 'Smart_Hill/B02/Rack_02',
    },
    {
      id: '65123223871815290',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B02',
      unitFullId: 'Smart_Hill/B02/Rack_03',
      fullFrontendId: 'Smart_Hill/B02/Rack_03',
    },
    {
      id: '18568289531407894',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B02',
      unitFullId: 'Smart_Hill/B02/Rack_04',
      fullFrontendId: 'Smart_Hill/B02/Rack_04',
    },
    {
      id: '7094469504664286',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B02',
      unitFullId: 'Smart_Hill/B02/Rack_05',
      fullFrontendId: 'Smart_Hill/B02/Rack_05',
    },
    {
      id: '36078247376804333',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B02',
      unitFullId: 'Smart_Hill/B02/Rack_06',
      fullFrontendId: 'Smart_Hill/B02/Rack_06',
    },
    {
      id: '36209438535110631',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B02',
      unitFullId: 'Smart_Hill/B02/Rack_07',
      fullFrontendId: 'Smart_Hill/B02/Rack_07',
    },
    {
      id: '35318091892249771',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B03',
      unitFullId: 'Smart_Hill/B03/Rack_01',
      fullFrontendId: 'Smart_Hill/B03/Rack_01',
    },
    {
      id: '14107409534745415',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B03',
      unitFullId: 'Smart_Hill/B03/Rack_02',
      fullFrontendId: 'Smart_Hill/B03/Rack_02',
    },
    {
      id: '49734039780099825',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B03',
      unitFullId: 'Smart_Hill/B03/Rack_03',
      fullFrontendId: 'Smart_Hill/B03/Rack_03',
    },
    {
      id: '41650961282610639',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B03',
      unitFullId: 'Smart_Hill/B03/Rack_04',
      fullFrontendId: 'Smart_Hill/B03/Rack_04',
    },
    {
      id: '62762969003009503',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B03',
      unitFullId: 'Smart_Hill/B03/Rack_05',
      fullFrontendId: 'Smart_Hill/B03/Rack_05',
    },
    {
      id: '41265578664303445',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B03',
      unitFullId: 'Smart_Hill/B03/Rack_06',
      fullFrontendId: 'Smart_Hill/B03/Rack_06',
    },
    {
      id: '52000826579640257',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B03',
      unitFullId: 'Smart_Hill/B03/Rack_07',
      fullFrontendId: 'Smart_Hill/B03/Rack_07',
    },
    {
      id: '38659240387588959',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B04',
      unitFullId: 'Smart_Hill/B04/Rack_01',
      fullFrontendId: 'Smart_Hill/B04/Rack_01',
    },
    {
      id: '31333048061248156',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B04',
      unitFullId: 'Smart_Hill/B04/Rack_02',
      fullFrontendId: 'Smart_Hill/B04/Rack_02',
    },
    {
      id: '49447700021204043',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B04',
      unitFullId: 'Smart_Hill/B04/Rack_03',
      fullFrontendId: 'Smart_Hill/B04/Rack_03',
    },
    {
      id: '17141526905007658',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B04',
      unitFullId: 'Smart_Hill/B04/Rack_04',
      fullFrontendId: 'Smart_Hill/B04/Rack_04',
    },
    {
      id: '32434374897784146',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B04',
      unitFullId: 'Smart_Hill/B04/Rack_05',
      fullFrontendId: 'Smart_Hill/B04/Rack_05',
    },
    {
      id: '24277162998605119',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B04',
      unitFullId: 'Smart_Hill/B04/Rack_06',
      fullFrontendId: 'Smart_Hill/B04/Rack_06',
    },
    {
      id: '47209317785957315',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B04',
      unitFullId: 'Smart_Hill/B04/Rack_07',
      fullFrontendId: 'Smart_Hill/B04/Rack_07',
    },
    {
      id: '61939568820839264',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B05',
      unitFullId: 'Smart_Hill/B05/Rack_01',
      fullFrontendId: 'Smart_Hill/B05/Rack_01',
    },
    {
      id: '47907067275323195',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B05',
      unitFullId: 'Smart_Hill/B05/Rack_02',
      fullFrontendId: 'Smart_Hill/B05/Rack_02',
    },
    {
      id: '48526863698603864',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B05',
      unitFullId: 'Smart_Hill/B05/Rack_03',
      fullFrontendId: 'Smart_Hill/B05/Rack_03',
    },
    {
      id: '25250069974272448',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B05',
      unitFullId: 'Smart_Hill/B05/Rack_04',
      fullFrontendId: 'Smart_Hill/B05/Rack_04',
    },
    {
      id: '5856479230073424',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B05',
      unitFullId: 'Smart_Hill/B05/Rack_05',
      fullFrontendId: 'Smart_Hill/B05/Rack_05',
    },
    {
      id: '20471540913518535',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B05',
      unitFullId: 'Smart_Hill/B05/Rack_06',
      fullFrontendId: 'Smart_Hill/B05/Rack_06',
    },
    {
      id: '50603710744382028',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B05',
      unitFullId: 'Smart_Hill/B05/Rack_07',
      fullFrontendId: 'Smart_Hill/B05/Rack_07',
    },
    {
      id: '21633242953326513',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B06',
      unitFullId: 'Smart_Hill/B06/Rack_01',
      fullFrontendId: 'Smart_Hill/B06/Rack_01',
    },
    {
      id: '63716930169321346',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B06',
      unitFullId: 'Smart_Hill/B06/Rack_02',
      fullFrontendId: 'Smart_Hill/B06/Rack_02',
    },
    {
      id: '4337717586297350',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B06',
      unitFullId: 'Smart_Hill/B06/Rack_03',
      fullFrontendId: 'Smart_Hill/B06/Rack_03',
    },
    {
      id: '1816065337026227',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B06',
      unitFullId: 'Smart_Hill/B06/Rack_04',
      fullFrontendId: 'Smart_Hill/B06/Rack_04',
    },
    {
      id: '23078986167548976',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B06',
      unitFullId: 'Smart_Hill/B06/Rack_05',
      fullFrontendId: 'Smart_Hill/B06/Rack_05',
    },
    {
      id: '37061098950414129',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B06',
      unitFullId: 'Smart_Hill/B06/Rack_06',
      fullFrontendId: 'Smart_Hill/B06/Rack_06',
    },
    {
      id: '46039135135769811',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B06',
      unitFullId: 'Smart_Hill/B06/Rack_07',
      fullFrontendId: 'Smart_Hill/B06/Rack_07',
    },
    {
      id: '56395827885335761',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B07',
      unitFullId: 'Smart_Hill/B07/Rack_01',
      fullFrontendId: 'Smart_Hill/B07/Rack_01',
    },
    {
      id: '68288132438534195',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B07',
      unitFullId: 'Smart_Hill/B07/Rack_02',
      fullFrontendId: 'Smart_Hill/B07/Rack_02',
    },
    {
      id: '42520939806310753',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B07',
      unitFullId: 'Smart_Hill/B07/Rack_03',
      fullFrontendId: 'Smart_Hill/B07/Rack_03',
    },
    {
      id: '14659260481768716',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B07',
      unitFullId: 'Smart_Hill/B07/Rack_04',
      fullFrontendId: 'Smart_Hill/B07/Rack_04',
    },
    {
      id: '9308028791642601',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B07',
      unitFullId: 'Smart_Hill/B07/Rack_05',
      fullFrontendId: 'Smart_Hill/B07/Rack_05',
    },
    {
      id: '42580670235822364',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B07',
      unitFullId: 'Smart_Hill/B07/Rack_06',
      fullFrontendId: 'Smart_Hill/B07/Rack_06',
    },
    {
      id: '7037076435548809',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B07',
      unitFullId: 'Smart_Hill/B07/Rack_07',
      fullFrontendId: 'Smart_Hill/B07/Rack_07',
    },
    {
      id: '2538918863590415',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B08',
      unitFullId: 'Smart_Hill/B08/Rack_01',
      fullFrontendId: 'Smart_Hill/B08/Rack_01',
    },
    {
      id: '36828021029146421',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B08',
      unitFullId: 'Smart_Hill/B08/Rack_02',
      fullFrontendId: 'Smart_Hill/B08/Rack_02',
    },
    {
      id: '51461022411741932',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B08',
      unitFullId: 'Smart_Hill/B08/Rack_03',
      fullFrontendId: 'Smart_Hill/B08/Rack_03',
    },
    {
      id: '62334855922460872',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B08',
      unitFullId: 'Smart_Hill/B08/Rack_04',
      fullFrontendId: 'Smart_Hill/B08/Rack_04',
    },
    {
      id: '25139187188403141',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B08',
      unitFullId: 'Smart_Hill/B08/Rack_05',
      fullFrontendId: 'Smart_Hill/B08/Rack_05',
    },
    {
      id: '59702983162494328',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B08',
      unitFullId: 'Smart_Hill/B08/Rack_06',
      fullFrontendId: 'Smart_Hill/B08/Rack_06',
    },
    {
      id: '25492131571971810',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B08',
      unitFullId: 'Smart_Hill/B08/Rack_07',
      fullFrontendId: 'Smart_Hill/B08/Rack_07',
    },
    {
      id: '7768783131568285',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B09',
      unitFullId: 'Smart_Hill/B09/Rack_01',
      fullFrontendId: 'Smart_Hill/B09/Rack_01',
    },
    {
      id: '25163592552586681',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B09',
      unitFullId: 'Smart_Hill/B09/Rack_02',
      fullFrontendId: 'Smart_Hill/B09/Rack_02',
    },
    {
      id: '26613609825343367',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B09',
      unitFullId: 'Smart_Hill/B09/Rack_03',
      fullFrontendId: 'Smart_Hill/B09/Rack_03',
    },
    {
      id: '28253986343896803',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B09',
      unitFullId: 'Smart_Hill/B09/Rack_04',
      fullFrontendId: 'Smart_Hill/B09/Rack_04',
    },
    {
      id: '31090759195636136',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B09',
      unitFullId: 'Smart_Hill/B09/Rack_05',
      fullFrontendId: 'Smart_Hill/B09/Rack_05',
    },
    {
      id: '67340213169365601',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B09',
      unitFullId: 'Smart_Hill/B09/Rack_06',
      fullFrontendId: 'Smart_Hill/B09/Rack_06',
    },
    {
      id: '11158484892686668',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B10',
      unitFullId: 'Smart_Hill/B10/Rack_01',
      fullFrontendId: 'Smart_Hill/B10/Rack_01',
    },
    {
      id: '68927473038752950',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B10',
      unitFullId: 'Smart_Hill/B10/Rack_02',
      fullFrontendId: 'Smart_Hill/B10/Rack_02',
    },
    {
      id: '50436436145897532',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B10',
      unitFullId: 'Smart_Hill/B10/Rack_03',
      fullFrontendId: 'Smart_Hill/B10/Rack_03',
    },
    {
      id: '39820713219009219',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B10',
      unitFullId: 'Smart_Hill/B10/Rack_04',
      fullFrontendId: 'Smart_Hill/B10/Rack_04',
    },
    {
      id: '49339515477753697',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B10',
      unitFullId: 'Smart_Hill/B10/Rack_05',
      fullFrontendId: 'Smart_Hill/B10/Rack_05',
    },
    {
      id: '28724523743614418',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B10',
      unitFullId: 'Smart_Hill/B10/Rack_06',
      fullFrontendId: 'Smart_Hill/B10/Rack_06',
    },
    {
      id: '13376914750853058',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B11',
      unitFullId: 'Smart_Hill/B11/Rack_01',
      fullFrontendId: 'Smart_Hill/B11/Rack_01',
    },
    {
      id: '56841109492578227',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B11',
      unitFullId: 'Smart_Hill/B11/Rack_02',
      fullFrontendId: 'Smart_Hill/B11/Rack_02',
    },
    {
      id: '10946992763985964',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B11',
      unitFullId: 'Smart_Hill/B11/Rack_03',
      fullFrontendId: 'Smart_Hill/B11/Rack_03',
    },
    {
      id: '35323450106053539',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B11',
      unitFullId: 'Smart_Hill/B11/Rack_04',
      fullFrontendId: 'Smart_Hill/B11/Rack_04',
    },
    {
      id: '3521236114852592',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B11',
      unitFullId: 'Smart_Hill/B11/Rack_05',
      fullFrontendId: 'Smart_Hill/B11/Rack_05',
    },
    {
      id: '13008081726865069',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B11',
      unitFullId: 'Smart_Hill/B11/Rack_06',
      fullFrontendId: 'Smart_Hill/B11/Rack_06',
    },
    {
      id: '49552413449274128',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B12',
      unitFullId: 'Smart_Hill/B12/Rack_01',
      fullFrontendId: 'Smart_Hill/B12/Rack_01',
    },
    {
      id: '30191853110409596',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B12',
      unitFullId: 'Smart_Hill/B12/Rack_02',
      fullFrontendId: 'Smart_Hill/B12/Rack_02',
    },
    {
      id: '28070762464680969',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B12',
      unitFullId: 'Smart_Hill/B12/Rack_03',
      fullFrontendId: 'Smart_Hill/B12/Rack_03',
    },
    {
      id: '69832781860857833',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B12',
      unitFullId: 'Smart_Hill/B12/Rack_04',
      fullFrontendId: 'Smart_Hill/B12/Rack_04',
    },
    {
      id: '22891281137356005',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B12',
      unitFullId: 'Smart_Hill/B12/Rack_05',
      fullFrontendId: 'Smart_Hill/B12/Rack_05',
    },
    {
      id: '32052106622291805',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B12',
      unitFullId: 'Smart_Hill/B12/Rack_06',
      fullFrontendId: 'Smart_Hill/B12/Rack_06',
    },
    {
      id: '38113168415355033',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B13',
      unitFullId: 'Smart_Hill/B13/Rack_01',
      fullFrontendId: 'Smart_Hill/B13/Rack_01',
    },
    {
      id: '14302806928450382',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B13',
      unitFullId: 'Smart_Hill/B13/Rack_02',
      fullFrontendId: 'Smart_Hill/B13/Rack_02',
    },
    {
      id: '62376281187427261',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B13',
      unitFullId: 'Smart_Hill/B13/Rack_03',
      fullFrontendId: 'Smart_Hill/B13/Rack_03',
    },
    {
      id: '17255494565430446',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B13',
      unitFullId: 'Smart_Hill/B13/Rack_04',
      fullFrontendId: 'Smart_Hill/B13/Rack_04',
    },
    {
      id: '7023040110786477',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B13',
      unitFullId: 'Smart_Hill/B13/Rack_05',
      fullFrontendId: 'Smart_Hill/B13/Rack_05',
    },
    {
      id: '26764239342805376',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B13',
      unitFullId: 'Smart_Hill/B13/Rack_06',
      fullFrontendId: 'Smart_Hill/B13/Rack_06',
    },
    {
      id: '30553784399725380',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B13',
      unitFullId: 'Smart_Hill/B13/Rack_07',
      fullFrontendId: 'Smart_Hill/B13/Rack_07',
    },
    {
      id: '47066440660800271',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B14',
      unitFullId: 'Smart_Hill/B14/Rack_01',
      fullFrontendId: 'Smart_Hill/B14/Rack_01',
    },
    {
      id: '13412229836202362',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B14',
      unitFullId: 'Smart_Hill/B14/Rack_02',
      fullFrontendId: 'Smart_Hill/B14/Rack_02',
    },
    {
      id: '3602344568108499',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B14',
      unitFullId: 'Smart_Hill/B14/Rack_03',
      fullFrontendId: 'Smart_Hill/B14/Rack_03',
    },
    {
      id: '44577104628557354',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B14',
      unitFullId: 'Smart_Hill/B14/Rack_04',
      fullFrontendId: 'Smart_Hill/B14/Rack_04',
    },
    {
      id: '30492556676042766',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B14',
      unitFullId: 'Smart_Hill/B14/Rack_05',
      fullFrontendId: 'Smart_Hill/B14/Rack_05',
    },
    {
      id: '70071017920417767',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B14',
      unitFullId: 'Smart_Hill/B14/Rack_06',
      fullFrontendId: 'Smart_Hill/B14/Rack_06',
    },
    {
      id: '33143413568738102',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B14',
      unitFullId: 'Smart_Hill/B14/Rack_07',
      fullFrontendId: 'Smart_Hill/B14/Rack_07',
    },
    {
      id: '21653856199572797',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B15',
      unitFullId: 'Smart_Hill/B15/Rack_01',
      fullFrontendId: 'Smart_Hill/B15/Rack_01',
    },
    {
      id: '27365264825782934',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B15',
      unitFullId: 'Smart_Hill/B15/Rack_02',
      fullFrontendId: 'Smart_Hill/B15/Rack_02',
    },
    {
      id: '63557573616345587',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B15',
      unitFullId: 'Smart_Hill/B15/Rack_03',
      fullFrontendId: 'Smart_Hill/B15/Rack_03',
    },
    {
      id: '23181206242594511',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B15',
      unitFullId: 'Smart_Hill/B15/Rack_04',
      fullFrontendId: 'Smart_Hill/B15/Rack_04',
    },
    {
      id: '62480409727017366',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B15',
      unitFullId: 'Smart_Hill/B15/Rack_05',
      fullFrontendId: 'Smart_Hill/B15/Rack_05',
    },
    {
      id: '14158364375943252',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B15',
      unitFullId: 'Smart_Hill/B15/Rack_06',
      fullFrontendId: 'Smart_Hill/B15/Rack_06',
    },
    {
      id: '11314509918393158',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B15',
      unitFullId: 'Smart_Hill/B15/Rack_07',
      fullFrontendId: 'Smart_Hill/B15/Rack_07',
    },
    {
      id: '17178712120278320',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B16',
      unitFullId: 'Smart_Hill/B16/Rack_01',
      fullFrontendId: 'Smart_Hill/B16/Rack_01',
    },
    {
      id: '26682097369265135',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B16',
      unitFullId: 'Smart_Hill/B16/Rack_02',
      fullFrontendId: 'Smart_Hill/B16/Rack_02',
    },
    {
      id: '23166424732939833',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B16',
      unitFullId: 'Smart_Hill/B16/Rack_03',
      fullFrontendId: 'Smart_Hill/B16/Rack_03',
    },
    {
      id: '52378953485546685',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B16',
      unitFullId: 'Smart_Hill/B16/Rack_04',
      fullFrontendId: 'Smart_Hill/B16/Rack_04',
    },
    {
      id: '17927613245815604',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B16',
      unitFullId: 'Smart_Hill/B16/Rack_05',
      fullFrontendId: 'Smart_Hill/B16/Rack_05',
    },
    {
      id: '65784297568105507',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B16',
      unitFullId: 'Smart_Hill/B16/Rack_06',
      fullFrontendId: 'Smart_Hill/B16/Rack_06',
    },
    {
      id: '8656234036716442',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B16',
      unitFullId: 'Smart_Hill/B16/Rack_07',
      fullFrontendId: 'Smart_Hill/B16/Rack_07',
    },
    {
      id: '10110088247115396',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B17',
      unitFullId: 'Smart_Hill/B17/Rack_01',
      fullFrontendId: 'Smart_Hill/B17/Rack_01',
    },
    {
      id: '2053692546559302',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B17',
      unitFullId: 'Smart_Hill/B17/Rack_02',
      fullFrontendId: 'Smart_Hill/B17/Rack_02',
    },
    {
      id: '70581178585199271',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B17',
      unitFullId: 'Smart_Hill/B17/Rack_03',
      fullFrontendId: 'Smart_Hill/B17/Rack_03',
    },
    {
      id: '52500410976540328',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B17',
      unitFullId: 'Smart_Hill/B17/Rack_04',
      fullFrontendId: 'Smart_Hill/B17/Rack_04',
    },
    {
      id: '24956673337015736',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B17',
      unitFullId: 'Smart_Hill/B17/Rack_05',
      fullFrontendId: 'Smart_Hill/B17/Rack_05',
    },
    {
      id: '35910466305307305',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B17',
      unitFullId: 'Smart_Hill/B17/Rack_06',
      fullFrontendId: 'Smart_Hill/B17/Rack_06',
    },
    {
      id: '32300504484497934',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B17',
      unitFullId: 'Smart_Hill/B17/Rack_07',
      fullFrontendId: 'Smart_Hill/B17/Rack_07',
    },
    {
      id: '50619950495859730',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B18',
      unitFullId: 'Smart_Hill/B18/Rack_01',
      fullFrontendId: 'Smart_Hill/B18/Rack_01',
    },
    {
      id: '38645722419021758',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B18',
      unitFullId: 'Smart_Hill/B18/Rack_02',
      fullFrontendId: 'Smart_Hill/B18/Rack_02',
    },
    {
      id: '28862791299318153',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B18',
      unitFullId: 'Smart_Hill/B18/Rack_03',
      fullFrontendId: 'Smart_Hill/B18/Rack_03',
    },
    {
      id: '45065540055841262',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B18',
      unitFullId: 'Smart_Hill/B18/Rack_04',
      fullFrontendId: 'Smart_Hill/B18/Rack_04',
    },
    {
      id: '38070773761938067',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B18',
      unitFullId: 'Smart_Hill/B18/Rack_05',
      fullFrontendId: 'Smart_Hill/B18/Rack_05',
    },
    {
      id: '63722519976061634',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B18',
      unitFullId: 'Smart_Hill/B18/Rack_06',
      fullFrontendId: 'Smart_Hill/B18/Rack_06',
    },
    {
      id: '52481637789387812',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B18',
      unitFullId: 'Smart_Hill/B18/Rack_07',
      fullFrontendId: 'Smart_Hill/B18/Rack_07',
    },
    {
      id: '48688770396985074',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B19',
      unitFullId: 'Smart_Hill/B19/Rack_01',
      fullFrontendId: 'Smart_Hill/B19/Rack_01',
    },
    {
      id: '14460835168906315',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B19',
      unitFullId: 'Smart_Hill/B19/Rack_02',
      fullFrontendId: 'Smart_Hill/B19/Rack_02',
    },
    {
      id: '52998696880078229',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B19',
      unitFullId: 'Smart_Hill/B19/Rack_03',
      fullFrontendId: 'Smart_Hill/B19/Rack_03',
    },
    {
      id: '31443814677279121',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B19',
      unitFullId: 'Smart_Hill/B19/Rack_04',
      fullFrontendId: 'Smart_Hill/B19/Rack_04',
    },
    {
      id: '49265051464892748',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B19',
      unitFullId: 'Smart_Hill/B19/Rack_05',
      fullFrontendId: 'Smart_Hill/B19/Rack_05',
    },
    {
      id: '38695840649889281',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B19',
      unitFullId: 'Smart_Hill/B19/Rack_06',
      fullFrontendId: 'Smart_Hill/B19/Rack_06',
    },
    {
      id: '1495526027727418',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B19',
      unitFullId: 'Smart_Hill/B19/Rack_07',
      fullFrontendId: 'Smart_Hill/B19/Rack_07',
    },
    {
      id: '48971081830872427',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B20',
      unitFullId: 'Smart_Hill/B20/Rack_01',
      fullFrontendId: 'Smart_Hill/B20/Rack_01',
    },
    {
      id: '48757661508021137',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B20',
      unitFullId: 'Smart_Hill/B20/Rack_02',
      fullFrontendId: 'Smart_Hill/B20/Rack_02',
    },
    {
      id: '4809815686882139',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B20',
      unitFullId: 'Smart_Hill/B20/Rack_03',
      fullFrontendId: 'Smart_Hill/B20/Rack_03',
    },
    {
      id: '48860916300418370',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B20',
      unitFullId: 'Smart_Hill/B20/Rack_04',
      fullFrontendId: 'Smart_Hill/B20/Rack_04',
    },
    {
      id: '7158730309284118',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B20',
      unitFullId: 'Smart_Hill/B20/Rack_05',
      fullFrontendId: 'Smart_Hill/B20/Rack_05',
    },
    {
      id: '45886904170386958',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B20',
      unitFullId: 'Smart_Hill/B20/Rack_06',
      fullFrontendId: 'Smart_Hill/B20/Rack_06',
    },
    {
      id: '41779508507157494',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B20',
      unitFullId: 'Smart_Hill/B20/Rack_07',
      fullFrontendId: 'Smart_Hill/B20/Rack_07',
    },
    {
      id: '49858423950880505',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B21',
      unitFullId: 'Smart_Hill/B21/Rack_01',
      fullFrontendId: 'Smart_Hill/B21/Rack_01',
    },
    {
      id: '46870689238557165',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B21',
      unitFullId: 'Smart_Hill/B21/Rack_02',
      fullFrontendId: 'Smart_Hill/B21/Rack_02',
    },
    {
      id: '40768168588328948',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B21',
      unitFullId: 'Smart_Hill/B21/Rack_03',
      fullFrontendId: 'Smart_Hill/B21/Rack_03',
    },
    {
      id: '56563756851894281',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B21',
      unitFullId: 'Smart_Hill/B21/Rack_04',
      fullFrontendId: 'Smart_Hill/B21/Rack_04',
    },
    {
      id: '63486783724460205',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B21',
      unitFullId: 'Smart_Hill/B21/Rack_05',
      fullFrontendId: 'Smart_Hill/B21/Rack_05',
    },
    {
      id: '17145910332195513',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B21',
      unitFullId: 'Smart_Hill/B21/Rack_06',
      fullFrontendId: 'Smart_Hill/B21/Rack_06',
    },
    {
      id: '53382178548989907',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B22',
      unitFullId: 'Smart_Hill/B22/Rack_01',
      fullFrontendId: 'Smart_Hill/B22/Rack_01',
    },
    {
      id: '71499463918202387',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B22',
      unitFullId: 'Smart_Hill/B22/Rack_02',
      fullFrontendId: 'Smart_Hill/B22/Rack_02',
    },
    {
      id: '34365075744484327',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B22',
      unitFullId: 'Smart_Hill/B22/Rack_03',
      fullFrontendId: 'Smart_Hill/B22/Rack_03',
    },
    {
      id: '70713094701696135',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B22',
      unitFullId: 'Smart_Hill/B22/Rack_04',
      fullFrontendId: 'Smart_Hill/B22/Rack_04',
    },
    {
      id: '35413507095972812',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B22',
      unitFullId: 'Smart_Hill/B22/Rack_05',
      fullFrontendId: 'Smart_Hill/B22/Rack_05',
    },
    {
      id: '30429192677332961',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B22',
      unitFullId: 'Smart_Hill/B22/Rack_06',
      fullFrontendId: 'Smart_Hill/B22/Rack_06',
    },
    {
      id: '48252989460899083',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B23',
      unitFullId: 'Smart_Hill/B23/Rack_01',
      fullFrontendId: 'Smart_Hill/B23/Rack_01',
    },
    {
      id: '6489621000364283',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B23',
      unitFullId: 'Smart_Hill/B23/Rack_02',
      fullFrontendId: 'Smart_Hill/B23/Rack_02',
    },
    {
      id: '65365547490194511',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B23',
      unitFullId: 'Smart_Hill/B23/Rack_03',
      fullFrontendId: 'Smart_Hill/B23/Rack_03',
    },
    {
      id: '60789031339525557',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B23',
      unitFullId: 'Smart_Hill/B23/Rack_04',
      fullFrontendId: 'Smart_Hill/B23/Rack_04',
    },
    {
      id: '32266837888722812',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B23',
      unitFullId: 'Smart_Hill/B23/Rack_05',
      fullFrontendId: 'Smart_Hill/B23/Rack_05',
    },
    {
      id: '27329678242489183',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B23',
      unitFullId: 'Smart_Hill/B23/Rack_06',
      fullFrontendId: 'Smart_Hill/B23/Rack_06',
    },
    {
      id: '19444713267498720',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B24',
      unitFullId: 'Smart_Hill/B24/Rack_01',
      fullFrontendId: 'Smart_Hill/B24/Rack_01',
    },
    {
      id: '2094862441585329',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B24',
      unitFullId: 'Smart_Hill/B24/Rack_02',
      fullFrontendId: 'Smart_Hill/B24/Rack_02',
    },
    {
      id: '53965937023473965',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B24',
      unitFullId: 'Smart_Hill/B24/Rack_03',
      fullFrontendId: 'Smart_Hill/B24/Rack_03',
    },
    {
      id: '71460987189680773',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B24',
      unitFullId: 'Smart_Hill/B24/Rack_04',
      fullFrontendId: 'Smart_Hill/B24/Rack_04',
    },
    {
      id: '27728366972216984',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B24',
      unitFullId: 'Smart_Hill/B24/Rack_05',
      fullFrontendId: 'Smart_Hill/B24/Rack_05',
    },
    {
      id: '48444700418667565',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B24',
      unitFullId: 'Smart_Hill/B24/Rack_06',
      fullFrontendId: 'Smart_Hill/B24/Rack_06',
    },
    {
      id: '35079599492552134',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B01',
      unitFullId: 'Sunset_Plaza/B01/Rack_01',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_01',
    },
    {
      id: '60657763325243915',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B01',
      unitFullId: 'Sunset_Plaza/B01/Rack_02',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_02',
    },
    {
      id: '43258961377223634',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B01',
      unitFullId: 'Sunset_Plaza/B01/Rack_03',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_03',
    },
    {
      id: '23354183706937396',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B01',
      unitFullId: 'Sunset_Plaza/B01/Rack_04',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_04',
    },
    {
      id: '1848370142396384',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B01',
      unitFullId: 'Sunset_Plaza/B01/Rack_05',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_05',
    },
    {
      id: '18480505217750404',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B01',
      unitFullId: 'Sunset_Plaza/B01/Rack_06',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_06',
    },
    {
      id: '43744028884453053',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B01',
      unitFullId: 'Sunset_Plaza/B01/Rack_07',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_07',
    },
    {
      id: '17553539178570896',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B01',
      unitFullId: 'Sunset_Plaza/B01/Rack_08',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_08',
    },
    {
      id: '22692834682381922',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B01',
      unitFullId: 'Sunset_Plaza/B01/Rack_09',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_09',
    },
    {
      id: '335446477564378',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B01',
      unitFullId: 'Sunset_Plaza/B01/Rack_10',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_10',
    },
    {
      id: '62459970151819100',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B02',
      unitFullId: 'Sunset_Plaza/B02/Rack_01',
      fullFrontendId: 'Sunset_Plaza/B02/Rack_01',
    },
    {
      id: '28726395311334323',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B02',
      unitFullId: 'Sunset_Plaza/B02/Rack_02',
      fullFrontendId: 'Sunset_Plaza/B02/Rack_02',
    },
    {
      id: '71351724769407902',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B02',
      unitFullId: 'Sunset_Plaza/B02/Rack_03',
      fullFrontendId: 'Sunset_Plaza/B02/Rack_03',
    },
    {
      id: '41945816501081001',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B02',
      unitFullId: 'Sunset_Plaza/B02/Rack_04',
      fullFrontendId: 'Sunset_Plaza/B02/Rack_04',
    },
    {
      id: '53265910630541263',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B02',
      unitFullId: 'Sunset_Plaza/B02/Rack_05',
      fullFrontendId: 'Sunset_Plaza/B02/Rack_05',
    },
    {
      id: '21037161735465121',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B02',
      unitFullId: 'Sunset_Plaza/B02/Rack_06',
      fullFrontendId: 'Sunset_Plaza/B02/Rack_06',
    },
    {
      id: '23563816371734243',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B02',
      unitFullId: 'Sunset_Plaza/B02/Rack_07',
      fullFrontendId: 'Sunset_Plaza/B02/Rack_07',
    },
    {
      id: '68483868567566294',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B02',
      unitFullId: 'Sunset_Plaza/B02/Rack_08',
      fullFrontendId: 'Sunset_Plaza/B02/Rack_08',
    },
    {
      id: '38135837023795626',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B02',
      unitFullId: 'Sunset_Plaza/B02/Rack_09',
      fullFrontendId: 'Sunset_Plaza/B02/Rack_09',
    },
    {
      id: '38904549177912417',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B02',
      unitFullId: 'Sunset_Plaza/B02/Rack_10',
      fullFrontendId: 'Sunset_Plaza/B02/Rack_10',
    },
    {
      id: '30714843013249091',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B03',
      unitFullId: 'Sunset_Plaza/B03/Rack_01',
      fullFrontendId: 'Sunset_Plaza/B03/Rack_01',
    },
    {
      id: '25788169519644835',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B03',
      unitFullId: 'Sunset_Plaza/B03/Rack_02',
      fullFrontendId: 'Sunset_Plaza/B03/Rack_02',
    },
    {
      id: '51197728079149998',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B03',
      unitFullId: 'Sunset_Plaza/B03/Rack_03',
      fullFrontendId: 'Sunset_Plaza/B03/Rack_03',
    },
    {
      id: '67052612123657520',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B03',
      unitFullId: 'Sunset_Plaza/B03/Rack_04',
      fullFrontendId: 'Sunset_Plaza/B03/Rack_04',
    },
    {
      id: '50017465982186910',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B03',
      unitFullId: 'Sunset_Plaza/B03/Rack_05',
      fullFrontendId: 'Sunset_Plaza/B03/Rack_05',
    },
    {
      id: '65050616771379947',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B03',
      unitFullId: 'Sunset_Plaza/B03/Rack_06',
      fullFrontendId: 'Sunset_Plaza/B03/Rack_06',
    },
    {
      id: '20647062452501250',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B03',
      unitFullId: 'Sunset_Plaza/B03/Rack_07',
      fullFrontendId: 'Sunset_Plaza/B03/Rack_07',
    },
    {
      id: '55047696560349703',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B03',
      unitFullId: 'Sunset_Plaza/B03/Rack_08',
      fullFrontendId: 'Sunset_Plaza/B03/Rack_08',
    },
    {
      id: '57672893553099070',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B03',
      unitFullId: 'Sunset_Plaza/B03/Rack_09',
      fullFrontendId: 'Sunset_Plaza/B03/Rack_09',
    },
    {
      id: '46294422344634429',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B03',
      unitFullId: 'Sunset_Plaza/B03/Rack_10',
      fullFrontendId: 'Sunset_Plaza/B03/Rack_10',
    },
    {
      id: '21031235340488397',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B04',
      unitFullId: 'Sunset_Plaza/B04/Rack_01',
      fullFrontendId: 'Sunset_Plaza/B04/Rack_01',
    },
    {
      id: '52104864305480172',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B04',
      unitFullId: 'Sunset_Plaza/B04/Rack_02',
      fullFrontendId: 'Sunset_Plaza/B04/Rack_02',
    },
    {
      id: '14078335744370971',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B04',
      unitFullId: 'Sunset_Plaza/B04/Rack_03',
      fullFrontendId: 'Sunset_Plaza/B04/Rack_03',
    },
    {
      id: '20280190013234747',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B04',
      unitFullId: 'Sunset_Plaza/B04/Rack_04',
      fullFrontendId: 'Sunset_Plaza/B04/Rack_04',
    },
    {
      id: '59713406893582856',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B04',
      unitFullId: 'Sunset_Plaza/B04/Rack_05',
      fullFrontendId: 'Sunset_Plaza/B04/Rack_05',
    },
    {
      id: '11850571627739532',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B04',
      unitFullId: 'Sunset_Plaza/B04/Rack_06',
      fullFrontendId: 'Sunset_Plaza/B04/Rack_06',
    },
    {
      id: '15619113561839834',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B04',
      unitFullId: 'Sunset_Plaza/B04/Rack_07',
      fullFrontendId: 'Sunset_Plaza/B04/Rack_07',
    },
    {
      id: '56019295785122494',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B04',
      unitFullId: 'Sunset_Plaza/B04/Rack_08',
      fullFrontendId: 'Sunset_Plaza/B04/Rack_08',
    },
    {
      id: '45233964787214109',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B04',
      unitFullId: 'Sunset_Plaza/B04/Rack_09',
      fullFrontendId: 'Sunset_Plaza/B04/Rack_09',
    },
    {
      id: '25285983738490723',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B04',
      unitFullId: 'Sunset_Plaza/B04/Rack_10',
      fullFrontendId: 'Sunset_Plaza/B04/Rack_10',
    },
    {
      id: '63358222093392503',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B05',
      unitFullId: 'Sunset_Plaza/B05/Rack_01',
      fullFrontendId: 'Sunset_Plaza/B05/Rack_01',
    },
    {
      id: '20917327876710154',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B05',
      unitFullId: 'Sunset_Plaza/B05/Rack_02',
      fullFrontendId: 'Sunset_Plaza/B05/Rack_02',
    },
    {
      id: '59723555043838889',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B05',
      unitFullId: 'Sunset_Plaza/B05/Rack_03',
      fullFrontendId: 'Sunset_Plaza/B05/Rack_03',
    },
    {
      id: '71731959769522196',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B05',
      unitFullId: 'Sunset_Plaza/B05/Rack_04',
      fullFrontendId: 'Sunset_Plaza/B05/Rack_04',
    },
    {
      id: '35527547318755671',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B05',
      unitFullId: 'Sunset_Plaza/B05/Rack_05',
      fullFrontendId: 'Sunset_Plaza/B05/Rack_05',
    },
    {
      id: '2160660447756477',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B05',
      unitFullId: 'Sunset_Plaza/B05/Rack_06',
      fullFrontendId: 'Sunset_Plaza/B05/Rack_06',
    },
    {
      id: '60955602330446930',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B05',
      unitFullId: 'Sunset_Plaza/B05/Rack_07',
      fullFrontendId: 'Sunset_Plaza/B05/Rack_07',
    },
    {
      id: '12129653793088123',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B05',
      unitFullId: 'Sunset_Plaza/B05/Rack_08',
      fullFrontendId: 'Sunset_Plaza/B05/Rack_08',
    },
    {
      id: '69127980137566436',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B05',
      unitFullId: 'Sunset_Plaza/B05/Rack_09',
      fullFrontendId: 'Sunset_Plaza/B05/Rack_09',
    },
    {
      id: '7177186809680055',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B05',
      unitFullId: 'Sunset_Plaza/B05/Rack_10',
      fullFrontendId: 'Sunset_Plaza/B05/Rack_10',
    },
    {
      id: '9175395037137693',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B06',
      unitFullId: 'Sunset_Plaza/B06/Rack_01',
      fullFrontendId: 'Sunset_Plaza/B06/Rack_01',
    },
    {
      id: '43840062496099364',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B06',
      unitFullId: 'Sunset_Plaza/B06/Rack_02',
      fullFrontendId: 'Sunset_Plaza/B06/Rack_02',
    },
    {
      id: '42336978694889711',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B06',
      unitFullId: 'Sunset_Plaza/B06/Rack_03',
      fullFrontendId: 'Sunset_Plaza/B06/Rack_03',
    },
    {
      id: '31450277216898505',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B06',
      unitFullId: 'Sunset_Plaza/B06/Rack_04',
      fullFrontendId: 'Sunset_Plaza/B06/Rack_04',
    },
    {
      id: '27192598374848000',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B06',
      unitFullId: 'Sunset_Plaza/B06/Rack_05',
      fullFrontendId: 'Sunset_Plaza/B06/Rack_05',
    },
    {
      id: '28102434435720603',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B06',
      unitFullId: 'Sunset_Plaza/B06/Rack_06',
      fullFrontendId: 'Sunset_Plaza/B06/Rack_06',
    },
    {
      id: '67399618892451013',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B06',
      unitFullId: 'Sunset_Plaza/B06/Rack_07',
      fullFrontendId: 'Sunset_Plaza/B06/Rack_07',
    },
    {
      id: '33778278923414646',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B06',
      unitFullId: 'Sunset_Plaza/B06/Rack_08',
      fullFrontendId: 'Sunset_Plaza/B06/Rack_08',
    },
    {
      id: '58760079855280155',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B06',
      unitFullId: 'Sunset_Plaza/B06/Rack_09',
      fullFrontendId: 'Sunset_Plaza/B06/Rack_09',
    },
    {
      id: '34135204102489899',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B06',
      unitFullId: 'Sunset_Plaza/B06/Rack_10',
      fullFrontendId: 'Sunset_Plaza/B06/Rack_10',
    },
    {
      id: '32437083433113149',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B07',
      unitFullId: 'Sunset_Plaza/B07/Rack_01',
      fullFrontendId: 'Sunset_Plaza/B07/Rack_01',
    },
    {
      id: '4416030866688505',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B07',
      unitFullId: 'Sunset_Plaza/B07/Rack_02',
      fullFrontendId: 'Sunset_Plaza/B07/Rack_02',
    },
    {
      id: '39763829747641606',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B07',
      unitFullId: 'Sunset_Plaza/B07/Rack_03',
      fullFrontendId: 'Sunset_Plaza/B07/Rack_03',
    },
    {
      id: '49909109682713087',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B07',
      unitFullId: 'Sunset_Plaza/B07/Rack_04',
      fullFrontendId: 'Sunset_Plaza/B07/Rack_04',
    },
    {
      id: '47543278782853757',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B07',
      unitFullId: 'Sunset_Plaza/B07/Rack_05',
      fullFrontendId: 'Sunset_Plaza/B07/Rack_05',
    },
    {
      id: '8670882970050692',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B07',
      unitFullId: 'Sunset_Plaza/B07/Rack_06',
      fullFrontendId: 'Sunset_Plaza/B07/Rack_06',
    },
    {
      id: '27283040611375227',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B07',
      unitFullId: 'Sunset_Plaza/B07/Rack_07',
      fullFrontendId: 'Sunset_Plaza/B07/Rack_07',
    },
    {
      id: '38035985200834664',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B07',
      unitFullId: 'Sunset_Plaza/B07/Rack_08',
      fullFrontendId: 'Sunset_Plaza/B07/Rack_08',
    },
    {
      id: '12174772515007284',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B07',
      unitFullId: 'Sunset_Plaza/B07/Rack_09',
      fullFrontendId: 'Sunset_Plaza/B07/Rack_09',
    },
    {
      id: '65698748464844387',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B07',
      unitFullId: 'Sunset_Plaza/B07/Rack_10',
      fullFrontendId: 'Sunset_Plaza/B07/Rack_10',
    },
    {
      id: '57142606006411498',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B08',
      unitFullId: 'Sunset_Plaza/B08/Rack_01',
      fullFrontendId: 'Sunset_Plaza/B08/Rack_01',
    },
    {
      id: '10958493489220936',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B08',
      unitFullId: 'Sunset_Plaza/B08/Rack_02',
      fullFrontendId: 'Sunset_Plaza/B08/Rack_02',
    },
    {
      id: '14754308508559561',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B08',
      unitFullId: 'Sunset_Plaza/B08/Rack_03',
      fullFrontendId: 'Sunset_Plaza/B08/Rack_03',
    },
    {
      id: '37940774952553839',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B08',
      unitFullId: 'Sunset_Plaza/B08/Rack_04',
      fullFrontendId: 'Sunset_Plaza/B08/Rack_04',
    },
    {
      id: '43509776735966515',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B08',
      unitFullId: 'Sunset_Plaza/B08/Rack_05',
      fullFrontendId: 'Sunset_Plaza/B08/Rack_05',
    },
    {
      id: '58135030007642909',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B08',
      unitFullId: 'Sunset_Plaza/B08/Rack_06',
      fullFrontendId: 'Sunset_Plaza/B08/Rack_06',
    },
    {
      id: '31414145010902092',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B08',
      unitFullId: 'Sunset_Plaza/B08/Rack_07',
      fullFrontendId: 'Sunset_Plaza/B08/Rack_07',
    },
    {
      id: '17818051774895706',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B08',
      unitFullId: 'Sunset_Plaza/B08/Rack_08',
      fullFrontendId: 'Sunset_Plaza/B08/Rack_08',
    },
    {
      id: '21013071767130086',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B08',
      unitFullId: 'Sunset_Plaza/B08/Rack_09',
      fullFrontendId: 'Sunset_Plaza/B08/Rack_09',
    },
    {
      id: '10801577876736588',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B08',
      unitFullId: 'Sunset_Plaza/B08/Rack_10',
      fullFrontendId: 'Sunset_Plaza/B08/Rack_10',
    },
    {
      id: '11375593899123091',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B09',
      unitFullId: 'Sunset_Plaza/B09/Rack_01',
      fullFrontendId: 'Sunset_Plaza/B09/Rack_01',
    },
    {
      id: '47381622689104084',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B09',
      unitFullId: 'Sunset_Plaza/B09/Rack_02',
      fullFrontendId: 'Sunset_Plaza/B09/Rack_02',
    },
    {
      id: '55709521646384897',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B09',
      unitFullId: 'Sunset_Plaza/B09/Rack_03',
      fullFrontendId: 'Sunset_Plaza/B09/Rack_03',
    },
    {
      id: '7302099969241602',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B09',
      unitFullId: 'Sunset_Plaza/B09/Rack_04',
      fullFrontendId: 'Sunset_Plaza/B09/Rack_04',
    },
    {
      id: '70994875044936437',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B09',
      unitFullId: 'Sunset_Plaza/B09/Rack_05',
      fullFrontendId: 'Sunset_Plaza/B09/Rack_05',
    },
    {
      id: '16576714102091540',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B09',
      unitFullId: 'Sunset_Plaza/B09/Rack_06',
      fullFrontendId: 'Sunset_Plaza/B09/Rack_06',
    },
    {
      id: '22491353107430450',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B09',
      unitFullId: 'Sunset_Plaza/B09/Rack_07',
      fullFrontendId: 'Sunset_Plaza/B09/Rack_07',
    },
    {
      id: '71333124671386150',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B09',
      unitFullId: 'Sunset_Plaza/B09/Rack_08',
      fullFrontendId: 'Sunset_Plaza/B09/Rack_08',
    },
    {
      id: '48508834435066572',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B09',
      unitFullId: 'Sunset_Plaza/B09/Rack_09',
      fullFrontendId: 'Sunset_Plaza/B09/Rack_09',
    },
    {
      id: '69392820513795688',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B09',
      unitFullId: 'Sunset_Plaza/B09/Rack_10',
      fullFrontendId: 'Sunset_Plaza/B09/Rack_10',
    },
    {
      id: '32660616734568296',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B10',
      unitFullId: 'Sunset_Plaza/B10/Rack_01',
      fullFrontendId: 'Sunset_Plaza/B10/Rack_01',
    },
    {
      id: '60902590282422794',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B10',
      unitFullId: 'Sunset_Plaza/B10/Rack_02',
      fullFrontendId: 'Sunset_Plaza/B10/Rack_02',
    },
    {
      id: '57024869034213961',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B10',
      unitFullId: 'Sunset_Plaza/B10/Rack_03',
      fullFrontendId: 'Sunset_Plaza/B10/Rack_03',
    },
    {
      id: '782363481701581',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B10',
      unitFullId: 'Sunset_Plaza/B10/Rack_04',
      fullFrontendId: 'Sunset_Plaza/B10/Rack_04',
    },
    {
      id: '17633189750374630',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B10',
      unitFullId: 'Sunset_Plaza/B10/Rack_05',
      fullFrontendId: 'Sunset_Plaza/B10/Rack_05',
    },
    {
      id: '69530651245263361',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B10',
      unitFullId: 'Sunset_Plaza/B10/Rack_06',
      fullFrontendId: 'Sunset_Plaza/B10/Rack_06',
    },
    {
      id: '48496545838971648',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B10',
      unitFullId: 'Sunset_Plaza/B10/Rack_07',
      fullFrontendId: 'Sunset_Plaza/B10/Rack_07',
    },
    {
      id: '66841037154927878',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B10',
      unitFullId: 'Sunset_Plaza/B10/Rack_08',
      fullFrontendId: 'Sunset_Plaza/B10/Rack_08',
    },
    {
      id: '70285715384723094',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B10',
      unitFullId: 'Sunset_Plaza/B10/Rack_09',
      fullFrontendId: 'Sunset_Plaza/B10/Rack_09',
    },
    {
      id: '63758290874505012',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B10',
      unitFullId: 'Sunset_Plaza/B10/Rack_10',
      fullFrontendId: 'Sunset_Plaza/B10/Rack_10',
    },
    {
      id: '28124858374632774',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B11',
      unitFullId: 'Sunset_Plaza/B11/Rack_01',
      fullFrontendId: 'Sunset_Plaza/B11/Rack_01',
    },
    {
      id: '47245680462390628',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B11',
      unitFullId: 'Sunset_Plaza/B11/Rack_02',
      fullFrontendId: 'Sunset_Plaza/B11/Rack_02',
    },
    {
      id: '45277147157392250',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B11',
      unitFullId: 'Sunset_Plaza/B11/Rack_03',
      fullFrontendId: 'Sunset_Plaza/B11/Rack_03',
    },
    {
      id: '60679825139275974',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B11',
      unitFullId: 'Sunset_Plaza/B11/Rack_04',
      fullFrontendId: 'Sunset_Plaza/B11/Rack_04',
    },
    {
      id: '56721372420565342',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B11',
      unitFullId: 'Sunset_Plaza/B11/Rack_05',
      fullFrontendId: 'Sunset_Plaza/B11/Rack_05',
    },
    {
      id: '22447779129517378',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B11',
      unitFullId: 'Sunset_Plaza/B11/Rack_06',
      fullFrontendId: 'Sunset_Plaza/B11/Rack_06',
    },
    {
      id: '5053232663135502',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B11',
      unitFullId: 'Sunset_Plaza/B11/Rack_07',
      fullFrontendId: 'Sunset_Plaza/B11/Rack_07',
    },
    {
      id: '69456142569331638',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B11',
      unitFullId: 'Sunset_Plaza/B11/Rack_08',
      fullFrontendId: 'Sunset_Plaza/B11/Rack_08',
    },
    {
      id: '31562446424791925',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B11',
      unitFullId: 'Sunset_Plaza/B11/Rack_09',
      fullFrontendId: 'Sunset_Plaza/B11/Rack_09',
    },
    {
      id: '67775263096565749',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B11',
      unitFullId: 'Sunset_Plaza/B11/Rack_10',
      fullFrontendId: 'Sunset_Plaza/B11/Rack_10',
    },
    {
      id: '57654656088194761',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B12',
      unitFullId: 'Sunset_Plaza/B12/Rack_01',
      fullFrontendId: 'Sunset_Plaza/B12/Rack_01',
    },
    {
      id: '69268198814781637',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B12',
      unitFullId: 'Sunset_Plaza/B12/Rack_02',
      fullFrontendId: 'Sunset_Plaza/B12/Rack_02',
    },
    {
      id: '12958175526162777',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B12',
      unitFullId: 'Sunset_Plaza/B12/Rack_03',
      fullFrontendId: 'Sunset_Plaza/B12/Rack_03',
    },
    {
      id: '55125871943037286',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B12',
      unitFullId: 'Sunset_Plaza/B12/Rack_04',
      fullFrontendId: 'Sunset_Plaza/B12/Rack_04',
    },
    {
      id: '56101294836430947',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B12',
      unitFullId: 'Sunset_Plaza/B12/Rack_05',
      fullFrontendId: 'Sunset_Plaza/B12/Rack_05',
    },
    {
      id: '19837581716408589',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B12',
      unitFullId: 'Sunset_Plaza/B12/Rack_06',
      fullFrontendId: 'Sunset_Plaza/B12/Rack_06',
    },
    {
      id: '56685402963130941',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B12',
      unitFullId: 'Sunset_Plaza/B12/Rack_07',
      fullFrontendId: 'Sunset_Plaza/B12/Rack_07',
    },
    {
      id: '71429198033057053',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B12',
      unitFullId: 'Sunset_Plaza/B12/Rack_08',
      fullFrontendId: 'Sunset_Plaza/B12/Rack_08',
    },
    {
      id: '19246583507602064',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B12',
      unitFullId: 'Sunset_Plaza/B12/Rack_09',
      fullFrontendId: 'Sunset_Plaza/B12/Rack_09',
    },
    {
      id: '12846182028686806',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B12',
      unitFullId: 'Sunset_Plaza/B12/Rack_10',
      fullFrontendId: 'Sunset_Plaza/B12/Rack_10',
    },
    {
      id: '51222084024797903',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B13',
      unitFullId: 'Sunset_Plaza/B13/Rack_01',
      fullFrontendId: 'Sunset_Plaza/B13/Rack_01',
    },
    {
      id: '39170229262137232',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B13',
      unitFullId: 'Sunset_Plaza/B13/Rack_02',
      fullFrontendId: 'Sunset_Plaza/B13/Rack_02',
    },
    {
      id: '3959540137519683',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B13',
      unitFullId: 'Sunset_Plaza/B13/Rack_03',
      fullFrontendId: 'Sunset_Plaza/B13/Rack_03',
    },
    {
      id: '71907166678705129',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B13',
      unitFullId: 'Sunset_Plaza/B13/Rack_04',
      fullFrontendId: 'Sunset_Plaza/B13/Rack_04',
    },
    {
      id: '2555834305027008',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B13',
      unitFullId: 'Sunset_Plaza/B13/Rack_05',
      fullFrontendId: 'Sunset_Plaza/B13/Rack_05',
    },
    {
      id: '60725584928870431',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B13',
      unitFullId: 'Sunset_Plaza/B13/Rack_06',
      fullFrontendId: 'Sunset_Plaza/B13/Rack_06',
    },
    {
      id: '66285326418257502',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B13',
      unitFullId: 'Sunset_Plaza/B13/Rack_07',
      fullFrontendId: 'Sunset_Plaza/B13/Rack_07',
    },
    {
      id: '4958850007594793',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B13',
      unitFullId: 'Sunset_Plaza/B13/Rack_08',
      fullFrontendId: 'Sunset_Plaza/B13/Rack_08',
    },
    {
      id: '23720656675694581',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B13',
      unitFullId: 'Sunset_Plaza/B13/Rack_09',
      fullFrontendId: 'Sunset_Plaza/B13/Rack_09',
    },
    {
      id: '1076878984484970',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B13',
      unitFullId: 'Sunset_Plaza/B13/Rack_10',
      fullFrontendId: 'Sunset_Plaza/B13/Rack_10',
    },
    {
      id: '23606146050822795',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B14',
      unitFullId: 'Sunset_Plaza/B14/Rack_01',
      fullFrontendId: 'Sunset_Plaza/B14/Rack_01',
    },
    {
      id: '44938263530984610',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B14',
      unitFullId: 'Sunset_Plaza/B14/Rack_02',
      fullFrontendId: 'Sunset_Plaza/B14/Rack_02',
    },
    {
      id: '61178743930976533',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B14',
      unitFullId: 'Sunset_Plaza/B14/Rack_03',
      fullFrontendId: 'Sunset_Plaza/B14/Rack_03',
    },
    {
      id: '13560460717256566',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B14',
      unitFullId: 'Sunset_Plaza/B14/Rack_04',
      fullFrontendId: 'Sunset_Plaza/B14/Rack_04',
    },
    {
      id: '54307276412371338',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B14',
      unitFullId: 'Sunset_Plaza/B14/Rack_05',
      fullFrontendId: 'Sunset_Plaza/B14/Rack_05',
    },
    {
      id: '50815937617313589',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B14',
      unitFullId: 'Sunset_Plaza/B14/Rack_06',
      fullFrontendId: 'Sunset_Plaza/B14/Rack_06',
    },
    {
      id: '3924482271833987',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B14',
      unitFullId: 'Sunset_Plaza/B14/Rack_07',
      fullFrontendId: 'Sunset_Plaza/B14/Rack_07',
    },
    {
      id: '35662694575693330',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B14',
      unitFullId: 'Sunset_Plaza/B14/Rack_08',
      fullFrontendId: 'Sunset_Plaza/B14/Rack_08',
    },
    {
      id: '8046538368927418',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B14',
      unitFullId: 'Sunset_Plaza/B14/Rack_09',
      fullFrontendId: 'Sunset_Plaza/B14/Rack_09',
    },
    {
      id: '33278398670163058',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B14',
      unitFullId: 'Sunset_Plaza/B14/Rack_10',
      fullFrontendId: 'Sunset_Plaza/B14/Rack_10',
    },
    {
      id: '13744263605342591',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B15',
      unitFullId: 'Sunset_Plaza/B15/Rack_01',
      fullFrontendId: 'Sunset_Plaza/B15/Rack_01',
    },
    {
      id: '24013042471477128',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B15',
      unitFullId: 'Sunset_Plaza/B15/Rack_02',
      fullFrontendId: 'Sunset_Plaza/B15/Rack_02',
    },
    {
      id: '33017895459320372',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B15',
      unitFullId: 'Sunset_Plaza/B15/Rack_03',
      fullFrontendId: 'Sunset_Plaza/B15/Rack_03',
    },
    {
      id: '13955951463951367',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B15',
      unitFullId: 'Sunset_Plaza/B15/Rack_04',
      fullFrontendId: 'Sunset_Plaza/B15/Rack_04',
    },
    {
      id: '68227863705749090',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B15',
      unitFullId: 'Sunset_Plaza/B15/Rack_05',
      fullFrontendId: 'Sunset_Plaza/B15/Rack_05',
    },
    {
      id: '19560451941931963',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B15',
      unitFullId: 'Sunset_Plaza/B15/Rack_06',
      fullFrontendId: 'Sunset_Plaza/B15/Rack_06',
    },
    {
      id: '48947680750511434',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B15',
      unitFullId: 'Sunset_Plaza/B15/Rack_07',
      fullFrontendId: 'Sunset_Plaza/B15/Rack_07',
    },
    {
      id: '24607581275318618',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B15',
      unitFullId: 'Sunset_Plaza/B15/Rack_08',
      fullFrontendId: 'Sunset_Plaza/B15/Rack_08',
    },
    {
      id: '43127281990156594',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B15',
      unitFullId: 'Sunset_Plaza/B15/Rack_09',
      fullFrontendId: 'Sunset_Plaza/B15/Rack_09',
    },
    {
      id: '49125336693456848',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B15',
      unitFullId: 'Sunset_Plaza/B15/Rack_10',
      fullFrontendId: 'Sunset_Plaza/B15/Rack_10',
    },
    {
      id: '42258704915988588',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B16',
      unitFullId: 'Sunset_Plaza/B16/Rack_01',
      fullFrontendId: 'Sunset_Plaza/B16/Rack_01',
    },
    {
      id: '45160022361051610',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B16',
      unitFullId: 'Sunset_Plaza/B16/Rack_02',
      fullFrontendId: 'Sunset_Plaza/B16/Rack_02',
    },
    {
      id: '206388036881247',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B16',
      unitFullId: 'Sunset_Plaza/B16/Rack_03',
      fullFrontendId: 'Sunset_Plaza/B16/Rack_03',
    },
    {
      id: '22164310707695651',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B16',
      unitFullId: 'Sunset_Plaza/B16/Rack_04',
      fullFrontendId: 'Sunset_Plaza/B16/Rack_04',
    },
    {
      id: '24697274947705184',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B16',
      unitFullId: 'Sunset_Plaza/B16/Rack_05',
      fullFrontendId: 'Sunset_Plaza/B16/Rack_05',
    },
    {
      id: '60233673394640248',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B16',
      unitFullId: 'Sunset_Plaza/B16/Rack_06',
      fullFrontendId: 'Sunset_Plaza/B16/Rack_06',
    },
    {
      id: '17580527052179391',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B16',
      unitFullId: 'Sunset_Plaza/B16/Rack_07',
      fullFrontendId: 'Sunset_Plaza/B16/Rack_07',
    },
    {
      id: '33521742613704712',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B16',
      unitFullId: 'Sunset_Plaza/B16/Rack_08',
      fullFrontendId: 'Sunset_Plaza/B16/Rack_08',
    },
    {
      id: '18833102232759435',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B16',
      unitFullId: 'Sunset_Plaza/B16/Rack_09',
      fullFrontendId: 'Sunset_Plaza/B16/Rack_09',
    },
    {
      id: '17913064679708754',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B16',
      unitFullId: 'Sunset_Plaza/B16/Rack_10',
      fullFrontendId: 'Sunset_Plaza/B16/Rack_10',
    },
    {
      id: '53828508804375926',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B17',
      unitFullId: 'Sunset_Plaza/B17/Rack_01',
      fullFrontendId: 'Sunset_Plaza/B17/Rack_01',
    },
    {
      id: '48670519692338213',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B17',
      unitFullId: 'Sunset_Plaza/B17/Rack_02',
      fullFrontendId: 'Sunset_Plaza/B17/Rack_02',
    },
    {
      id: '13208265763049318',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B17',
      unitFullId: 'Sunset_Plaza/B17/Rack_03',
      fullFrontendId: 'Sunset_Plaza/B17/Rack_03',
    },
    {
      id: '19552475340290172',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B17',
      unitFullId: 'Sunset_Plaza/B17/Rack_04',
      fullFrontendId: 'Sunset_Plaza/B17/Rack_04',
    },
    {
      id: '4898952035945218',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B17',
      unitFullId: 'Sunset_Plaza/B17/Rack_05',
      fullFrontendId: 'Sunset_Plaza/B17/Rack_05',
    },
    {
      id: '15850813590925959',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B17',
      unitFullId: 'Sunset_Plaza/B17/Rack_06',
      fullFrontendId: 'Sunset_Plaza/B17/Rack_06',
    },
    {
      id: '52521187362286770',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B17',
      unitFullId: 'Sunset_Plaza/B17/Rack_07',
      fullFrontendId: 'Sunset_Plaza/B17/Rack_07',
    },
    {
      id: '54430293987184687',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B17',
      unitFullId: 'Sunset_Plaza/B17/Rack_08',
      fullFrontendId: 'Sunset_Plaza/B17/Rack_08',
    },
    {
      id: '23213235943792871',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B17',
      unitFullId: 'Sunset_Plaza/B17/Rack_09',
      fullFrontendId: 'Sunset_Plaza/B17/Rack_09',
    },
    {
      id: '26385332725240731',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B17',
      unitFullId: 'Sunset_Plaza/B17/Rack_10',
      fullFrontendId: 'Sunset_Plaza/B17/Rack_10',
    },
    {
      id: '43089236366906994',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B18',
      unitFullId: 'Sunset_Plaza/B18/Rack_01',
      fullFrontendId: 'Sunset_Plaza/B18/Rack_01',
    },
    {
      id: '63768954693150466',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B18',
      unitFullId: 'Sunset_Plaza/B18/Rack_02',
      fullFrontendId: 'Sunset_Plaza/B18/Rack_02',
    },
    {
      id: '35095534864345407',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B18',
      unitFullId: 'Sunset_Plaza/B18/Rack_03',
      fullFrontendId: 'Sunset_Plaza/B18/Rack_03',
    },
    {
      id: '17801485971336608',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B18',
      unitFullId: 'Sunset_Plaza/B18/Rack_04',
      fullFrontendId: 'Sunset_Plaza/B18/Rack_04',
    },
    {
      id: '49077479741439416',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B18',
      unitFullId: 'Sunset_Plaza/B18/Rack_05',
      fullFrontendId: 'Sunset_Plaza/B18/Rack_05',
    },
    {
      id: '45129314086819167',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B18',
      unitFullId: 'Sunset_Plaza/B18/Rack_06',
      fullFrontendId: 'Sunset_Plaza/B18/Rack_06',
    },
    {
      id: '6179717183598613',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B18',
      unitFullId: 'Sunset_Plaza/B18/Rack_07',
      fullFrontendId: 'Sunset_Plaza/B18/Rack_07',
    },
    {
      id: '37367737864105152',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B18',
      unitFullId: 'Sunset_Plaza/B18/Rack_08',
      fullFrontendId: 'Sunset_Plaza/B18/Rack_08',
    },
    {
      id: '69588164753444757',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B18',
      unitFullId: 'Sunset_Plaza/B18/Rack_09',
      fullFrontendId: 'Sunset_Plaza/B18/Rack_09',
    },
    {
      id: '68228446603551146',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B18',
      unitFullId: 'Sunset_Plaza/B18/Rack_10',
      fullFrontendId: 'Sunset_Plaza/B18/Rack_10',
    },
    {
      id: '17284153773455137',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B19',
      unitFullId: 'Sunset_Plaza/B19/Rack_01',
      fullFrontendId: 'Sunset_Plaza/B19/Rack_01',
    },
    {
      id: '48806938598024116',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B19',
      unitFullId: 'Sunset_Plaza/B19/Rack_02',
      fullFrontendId: 'Sunset_Plaza/B19/Rack_02',
    },
    {
      id: '11986804017601896',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B19',
      unitFullId: 'Sunset_Plaza/B19/Rack_03',
      fullFrontendId: 'Sunset_Plaza/B19/Rack_03',
    },
    {
      id: '61098197719043385',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B19',
      unitFullId: 'Sunset_Plaza/B19/Rack_04',
      fullFrontendId: 'Sunset_Plaza/B19/Rack_04',
    },
    {
      id: '66184847427690058',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B19',
      unitFullId: 'Sunset_Plaza/B19/Rack_05',
      fullFrontendId: 'Sunset_Plaza/B19/Rack_05',
    },
    {
      id: '26575516861154073',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B19',
      unitFullId: 'Sunset_Plaza/B19/Rack_06',
      fullFrontendId: 'Sunset_Plaza/B19/Rack_06',
    },
    {
      id: '34619842153783870',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B19',
      unitFullId: 'Sunset_Plaza/B19/Rack_07',
      fullFrontendId: 'Sunset_Plaza/B19/Rack_07',
    },
    {
      id: '10040882121069437',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B19',
      unitFullId: 'Sunset_Plaza/B19/Rack_08',
      fullFrontendId: 'Sunset_Plaza/B19/Rack_08',
    },
    {
      id: '60695585843713864',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B19',
      unitFullId: 'Sunset_Plaza/B19/Rack_09',
      fullFrontendId: 'Sunset_Plaza/B19/Rack_09',
    },
    {
      id: '26927875387232999',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B19',
      unitFullId: 'Sunset_Plaza/B19/Rack_10',
      fullFrontendId: 'Sunset_Plaza/B19/Rack_10',
    },
  ],
};
